export default {
  name: "Tên",
  tel: "Điện thoại",
  save: "Lưu",
  confirm: "Xác nhận",
  cancel: "Hủy",
  delete: "Xóa",
  complete: "Hoàn thành",
  loading: "Đang tải...",
  telEmpty: "Vui lòng nhập số điện thoại",
  nameEmpty: "Vui lòng nhập tên",
  nameInvalid: "Vui lòng nhập tên hợp lệ",
  confirmDelete: "Bạn có chắc chắn muốn xóa không?",
  telInvalid: "Vui lòng nhập số điện thoại hợp lệ",
  SelectYearMonthDay: "Chọn Năm, Tháng, Ngày",
  vanCalendar: {
    end: "Kết thúc",
    start: "Bắt đầu",
    title: "Chọn ngày",
    confirm: "Xác nhận",
    startEnd: "Bắt đầu/Kết thúc",
    weekdays: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    monthTitle: (year, month) => `Tháng ${month} năm ${year}`,
    rangePrompt: (maxRange) => `Không thể chọn quá ${maxRange} ngày`,
  },
  vanCascader: {
    select: "Vui lòng chọn",
  },
  vanContactCard: {
    addText: "Thêm liên hệ",
  },
  vanContactList: {
    addText: "Thêm liên hệ mới",
  },
  vanPagination: {
    prev: "Trang trước",
    next: "Trang sau",
  },
  vanPullRefresh: {
    pulling: "Kéo xuống để làm mới...",
    loosing: "Thả ra để làm mới...",
  },
  vanSubmitBar: {
    label: "Tổng cộng:",
  },
  vanCoupon: {
    unlimited: "Không giới hạn sử dụng",
    discount: (discount) => `Giảm ${discount}%`,
    condition: (condition) => `Áp dụng cho đơn từ ${condition}`,
  },
  vanCouponCell: {
    title: "Phiếu giảm giá",
    tips: "Không có phiếu khả dụng",
    count: (count) => `${count} phiếu khả dụng`,
  },
  vanCouponList: {
    empty: "Không có phiếu giảm giá",
    exchange: "Đổi",
    close: "Không sử dụng",
    enable: "Khả dụng",
    disabled: "Không khả dụng",
    placeholder: "Nhập mã giảm giá",
  },
  vanAddressEdit: {
    area: "Khu vực",
    postal: "Mã bưu chính",
    areaEmpty: "Vui lòng chọn khu vực",
    addressEmpty: "Vui lòng nhập địa chỉ chi tiết",
    postalEmpty: "Mã bưu chính không hợp lệ",
    defaultAddress: "Đặt làm địa chỉ mặc định",
    telPlaceholder: "Số điện thoại người nhận",
    namePlaceholder: "Tên người nhận",
    areaPlaceholder: "Chọn Tỉnh / Thành phố / Quận",
  },
  vanAddressEditDetail: {
    label: "Địa chỉ chi tiết",
    placeholder: "Số nhà, tên đường, tầng, số phòng",
  },
  vanAddressList: {
    add: "Thêm địa chỉ mới",
  },
  realName: "Họ tên thật",
  idCard: "CMND/CCCD",

  unionManagement: {
    GuildRegistration: "Đăng ký Guild",
    GuildSettlementWelcomeLine1: "Chào mừng đến",
    GuildSettlementWelcomeLine2: "guild Rain Chat",
    GuildSettlementFormBanner: "Vui lòng điền thông tin tham gia guild",
    ApplicantID: "ID Người đăng ký",
    GuildName: "Tên Guild",
    PleaseGuildName: "Vui lòng nhập tên guild",
    PleaseGuildID: "Vui lòng nhập ID Guild",
    PleaseInformation: "Vui lòng nhập thông tin liên hệ",
    PlatformsWith: "Các nền tảng đã hợp tác",
    ListOfplatforms: "Liệt kê các nền tảng đã hợp tác",
    GuildSize: "Quy mô Guild",
    EstimatedNumber: "Số lượng streamer dự kiến",
    Notes: "Lưu ý: Liên hệ trưởng guild hoặc thành viên để lấy ID guild",
    Submit: "Gửi",
    SubmitSuccess: "Gửi thành công",
    MyGuild: "Guild của tôi",
    VoiceHallOnboarding: "Đăng ký Phòng Giọng nói",
    WelcomeRainChatVoice: "Welcome to Rain Chat Voice",
    VoiceHallJoinFormBanner: "Vui lòng điền thông tin tham gia phòng",
    VoiceHallName: "Tên bang hội thoại",
    PleaseVoiceHallName: "Vui lòng nhập tên bang hội thoại",
    VoiceHallRealName: "Họ tên thật",
    PleaseVoiceHallRealName: "Vui lòng nhập họ tên thật của bạn",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "Vui lòng nhập thông tin liên hệ",
    PlatformsCollaborated: "Các nền tảng đã hợp tác",
    ListPlatformsCollaborated: "Liệt kê các nền tảng đã hợp tác",
    VoiceHallScale: "Quy mô bang hội thoại",
    EstimatedAnchors: "Số lượng streamer dự kiến của phòng giọng nói",
    CertificationType: "Loại Chứng nhận",
    VoiceHall: "Phòng Giọng nói",
    VoiceGuild: "Guild Giọng nói",
    HostName: "Tên streamer",
    GuildJoinDate: "Ngày tham gia Guild",
    TotalMembers: "Tổng số thành viên Guild",
    TotalPeople: "Tổng số người",
    RoomNicknameLabel: "Biệt danh phòng",
    DataDetails: "Chi tiết dữ liệu",
    PleaseHostID: "Vui lòng nhập ID streamer",
    Search: "Tìm kiếm",
    KickOut: "Kick",
    NoData: "Không có dữ liệu",

    InformationData: "Thông tin dữ liệu",
    Name: "Họ tên",
    PleaseID: "Vui lòng nhập đúng tên trên CMND/CCCD",
    IdentityCard: "CMND/CCCD",
    YourIDnumber: "Số CMND/CCCD của bạn",
    IDPhoto: "Ảnh CMND/CCCD",
    PleasePhoto: "Vui lòng tải lên ảnh CMND/CCCD",
    FrontofID: "Mặt trước CMND/CCCD",
    BackofID: "Mặt sau CMND/CCCD",
    NotePlease:
      "Lưu ý: Vui lòng tải lên ảnh cầm CMND/CCCD, khuôn mặt rõ ràng không che chắn, ảnh và số CMND/CCCD phải rõ ràng",
    Country: "Quốc gia",
    SelectCountryorRegion: "Chọn Quốc gia/Khu vực",
    BankName: "Tên ngân hàng",
    Pleasebankname: "Vui lòng nhập tên ngân hàng",
    BankCardNumber: "Số tài khoản",
    Pleasebankcardnumber: "Vui lòng nhập số tài khoản",
    BankCardHolder: "Chủ tài khoản",
    Pleasebankcardholder: "Vui lòng nhập tên chủ tài khoản",
    PhoneNumber: "Số điện thoại",
    Enterphonenumber: "Nhập số điện thoại hợp lệ",
    Notebankaccount: "Lưu ý: Vui lòng nhập số điện thoại đăng ký ngân hàng",
    WhatsAppContactInformation: "Thông tin liên hệ WhatsApp",
    Pleaseownnumber: "Vui lòng nhập số điện thoại của bạn",
    Notecollaborationmatters:
      "Lưu ý: Số WhatsApp của guild sẽ được sử dụng làm phương thức liên hệ duy nhất cho các vấn đề hợp tác",
    Email: "Email",
    Pleaseemailaddress: "Vui lòng nhập email của bạn",
    Notematters:
      "Lưu ý: Email của guild sẽ được sử dụng làm phương thức liên hệ duy nhất cho các vấn đề hợp tác",
    BasicInformationSection: "Thông tin cơ bản",
    RemarksInformationSection: "Thông tin bổ sung",

    SpecialGiftDetails: "Chi tiết quà tặng đặc biệt",
    CurrentDate: "Ngày hiện tại",
    GoldCoinTransactions: "Lợi nhuận may mắn của đậu vàng",
    LiveStreamingDuration: "Thời gian phát sóng",
    GoldBeanEarnings: "Thu nhập đậu vàng",
    EffectiveDays: "Số ngày hiệu lực",
    WarningCount: "Số lần cảnh báo",

    give: "Tặng",
    pleasewait: "Đang xử lý, vui lòng đợi...",

    JoinGuild: "Tham gia Guild",
    GuildId: "ID Guild",
    PlaceholderGuildId: "Vui lòng nhập ID Guild",
    PlaceholderInvitationCode: "Vui lòng nhập mã mời guild của bạn",

    InvitationCode: "Mã mời",

    noMore: "Không còn nữa",

    Recommendation: "Người giới thiệu (tùy chọn)",
    nightLiveTime: "Thời gian đặc biệt",

    // Trang Dữ Liệu Guild
    GuildTotalData: "Tổng dữ liệu guild",
    StatDayUnit: "",
    GuildIncome: "Thu Nhập Guild",
    AnchorIncome: "Thu Nhập Anchor",
    EffectiveLive: "Phát Sóng Hiệu Quả",
    EffectiveDays: "Ngày Hiệu Quả",
    Income: "Thu Nhập",
    Duration: "Thời Lượng",

    // Join Us Page
    JoinUs: "Tham Gia Cùng Chúng Tôi",
    JoinUsWelcome: "Hi, chào mừng bạn tham gia cùng chúng tôi～",
    JoinUsSelectMethod: "Vui lòng chọn cách tham gia",
    JoinUsVideoGuild: "Tham gia với tư cách Hội Video",
    JoinUsVideoGuildDesc: "Bạn sẽ tập trung vào phát trực tiếp video",
    JoinUsAudioGuild: "Tham gia với tư cách Hội Âm Thanh",
    JoinUsAudioGuildDesc: "Bạn sẽ tập trung vào phát trực tiếp âm thanh",
    JoinUsBack: "Quay Lại",
  },

  familyMain: {
    anchorList: "Danh sách Anchor",
    anchorData: "Dữ liệu Anchor",
    guildData: "Dữ liệu guild",
    guildSummaryTitle: "Tổng hợp guild",
    guildList: "Danh sách guild",
    micTime: "Thời gian Mic",
    micTimeData: "Dữ liệu thời gian Mic",
    beansDetail: "Chi tiết Đậu vàng",
    beansDetailData: "Dữ liệu chi tiết Đậu vàng",
    withdrawDetail: "Chi tiết rút tiền",
    withdrawDetailData: "Dữ liệu chi tiết rút tiền",
    roomData: "Dữ liệu phòng",
    roomDataData: "Dữ liệu phòng",
    distributeBeans: "Phân phối Đậu vàng",
    distributeBeansData: "Dữ liệu phân phối Đậu vàng",
    privateShareStats: "Thống kê tin nhắn/chia sẻ",
    privateShareStatsData: "Dữ liệu thống kê tin nhắn/chia sẻ",
    roomTurnover: "Doanh thu phòng",
    roomTurnoverData: "Dữ liệu doanh thu phòng",
    incomeRecord: "Lịch sử thu nhập",
    incomeRecordData: "Dữ liệu lịch sử thu nhập",
    knapsackGiftDetail: "Chi tiết quà túi đồ",
    knapsackGiftData: "Dữ liệu quà túi đồ",
    roomFilterTitle: "Bộ lọc phòng",
    roomFilterConfirm: "Hoàn tất",
    allRooms: "Tất cả phòng",
    selectRoom: "Chọn phòng",
  },
  anchorList: {
    countLabel: "【{count} streamer】",
    searchPlaceholder: "Nhập ID streamer",
    search: "Tìm kiếm",
    joinTimeLabel: "Thời gian tham gia：",
    noData: "Không có dữ liệu",
    nickNameFallback: "Tên streamer",
    invalidUserId: "Vui lòng nhập ID là số",
  },

  salaryMain: {
    searchPlaceholder: "Nhập ID anchor để tìm kiếm",
    dateSelect: "Chọn ngày",
    byDay: "Theo ngày",
    byRange: "Theo khoảng",
    searchTime: "Thời gian tìm kiếm",
    to: " đến ",
    dataSummary: "Tổng hợp dữ liệu",
    totalMicTime: "Tổng thời gian Mic",
    totalHeartGiftTurnover: "Tổng đậu vàng may mắn",
    totalLuxuryGiftTurnover: "Tổng đậu vàng",
    member: "Thành viên",
    anchorProfile: "Hồ sơ Anchor",
    micTime: "Thời gian Mic",
    heartGiftTurnover: "Đậu vàng may mắn",
    luxuryGiftTurnover: "Tổng đậu vàng",
    roomNumber: "Số phòng",
    pleaseSelectTime: "Chọn thời gian",
    pleaseEnterNumber: "Vui lòng nhập số",
    selectAll: "Chọn tất cả",
    minute: "phút",
    second: "giây",
    anchorTotalData: "Tổng dữ liệu anchor",
    totalSpecialEffectBeans: "Tổng đậu vàng hiệu ứng",
    totalAllBeans: "Tổng đậu vàng",
  },

  anchorCenter: {
    todayLiveData: "Dữ liệu livestream hôm nay",
    time: "Thời gian",
    duration: "Thời lượng",
    income: "Thu nhập đậu vàng may mắn",
    giftRecord: "Lịch sử quà tặng",
    withdraw: "Rút tiền",
    tipsUpdate: "Lưu ý: Dữ liệu trong ngày được cập nhật mỗi phút",
    overallData: "Dữ liệu tổng thể",
    totalDays: "Tổng số ngày",
    totalDuration: "Tổng thời lượng",
    totalTurnover: "Tổng đậu vàng may mắn",
    totalIncome: "Tổng lương cơ bản",
    totalBeans: "Tổng đậu vàng",
    luckyBeans: "Đậu vàng may mắn",
    specialBeans: "Đậu vàng hiệu ứng",
    baseSalary: "Lương cơ bản",
    totalIncomeLabel: "Tổng thu nhập",
    dataListMonth: "Danh sách dữ liệu [{month}]",
    filter: "Lọc",
    date: "Ngày",
    turnover: "Doanh thu",
    beans: "Đậu vàng",
    zeroTime: "0h 0m",
    year: "",
    month: "",
    anchorTotalData: "Tổng dữ liệu anchor",
    anchorNicknamePlaceholder: "Biệt danh anchor",
    myGuild: "Guild của tôi",
    guildNicknamePlaceholder: "Biệt danh guild",
    anchorDataSection: "Dữ liệu anchor",
    todayDataTitle: "Dữ liệu hôm nay",
    liveStreamDuration: "Thời lượng live",
    totalGoldBeans: "Tổng đậu vàng",
    nextDayLuckyReward: "Thưởng may mắn ngày hôm sau",
    specialExtraReward: "Thưởng thêm hiệu ứng",
    weekLuckyReward: "Thưởng may mắn tuần này",
    estimatedTotalEarnings: "Tổng thu nhập dự kiến",
    grandTotal: "Tổng cộng",
  },

  micTime: {
    searchPlaceholder: "Nhập ID anchor",
    search: "Tìm kiếm",
    dateSelect: "Chọn ngày",
    today: "Hôm nay",
    thisWeek: "Tuần này",
    lastWeek: "Tuần trước",
    totalMicTime: "Tổng thời gian Mic",
    date: "Ngày",
    anchorInfo: "Thông tin Anchor",
    micTime: "Thời gian Mic",
    pleaseSelectTime: "Chọn thời gian",
    selectAll: "Chọn tất cả",
    minute: "phút",
    second: "giây",
  },

  anchroOtayonii: {
    dateSelect: "Chọn ngày",
    byDay: "Theo ngày",
    byRange: "Theo khoảng",
    searchTime: "Thời gian tìm kiếm",
    to: " đến ",
    dataSummary: "Tổng hợp dữ liệu",
    totalLuckyGift: "Tổng quà Lucky",
    totalSpecialGift: "Tổng quà Special",
    totalKnapsackGift: "Tổng quà Knapsack",
    anchorInfo: "Thông tin Anchor",
    luckyGift: "Quà Lucky",
    specialGift: "Quà Special",
    knapsackGift: "Quà Knapsack",
    pleaseSelectTime: "Chọn thời gian",
    selectAll: "Chọn tất cả",
  },

  roomCm: {
    dateSelect: "Chọn ngày",
    today: "Hôm nay",
    thisWeek: "Tuần này",
    lastWeek: "Tuần trước",
    dataSummary: "Tổng hợp dữ liệu",
    totalTurnover: "Tổng đậu vàng may mắn",
    totalTurnoverBeans: "Tổng đậu vàng",
    date: "Ngày",
    heartGiftTurnover: "Đậu vàng may mắn",
    specialGiftTurnover: "Tổng đậu vàng",
    room: "Phòng",
    pleaseSelectTime: "Chọn thời gian",
    selectAll: "Chọn tất cả",
    minute: "phút",
    second: "giây",
  },

  weekProfit: {
    dateSelect: "Chọn ngày",
    time: "Thời gian",
    type: "Loại",
    beans: "Đậu",
    pleaseSelectTime: "Chọn thời gian",
  },

  withdrawRecord: {
    withdrawAmount: "Số tiền rút",
    withdrawStatus: "Trạng thái rút tiền",
    NoData: "Không có dữ liệu",

    UnderReview: "Đang xét duyệt",
    Processing: "Đang xử lý",
    Completed: "Đã hoàn thành",
    Rejected: "Đã từ chối",
    Failed: "Thất bại",

    Pending: "Đang chờ",
    Success: "Thành công",
    NoMore: "Không còn nữa",
    PleaseWait: "Đang xử lý, vui lòng đợi...",
    PleaseSelect: "Vui lòng chọn",
    Date: "Ngày",
    RealAmount: "Số tiền thực nhận",
    Fee: "Phí",
    Status: "Trạng thái",
    Remark: "Ghi chú",
  },

  coinManagement: {
    myGoldenbeans: "Đậu vàng của tôi",
    Withdraw: "Rút tiền",
    ExchangeGoldCoins: "Đổi xu",
    HostInformation: "Thông tin streamer",
    WithdrawalCurrency: "Loại tiền rút",
    SelectWithdrawalCurrency: "Vui lòng chọn loại tiền rút",
    FiatCurrency: "Tiền pháp định",
    PleaseSelectWithdrawalCurrency: "Vui lòng chọn loại tiền rút",
    tips: "Lưu ý:",
    tipsp0: "Tỷ lệ rút tiền: 10.000 đậu vàng = 0,5 USD",
    tipsp1:
      "Mức tối thiểu rút: 100,000 đậu vàng, chỉ có thể rút theo bội số của 10,000 (lần rút đầu tiên cần 200,000 đậu vàng, sau khi rút thành công mức tối thiểu sẽ giảm xuống 100,000)",
    tipsp2:
      "Liên kết tài khoản rút tiền. Do đa dạng phương thức thanh toán quốc tế và không có giấy tờ cố định, hệ thống cần nhiều loại xác thực khi thêm tài khoản trưởng gia tộc [phương thức thanh toán cụ thể tùy tình hình hiện tại]",
    tipsp3: "Cần xác minh Host",
    tipsp4: "Liên kết số điện thoại",
    tipsp5:
      "Nếu chưa hoàn thành bất kỳ bước nào trên, sẽ không thể rút tiền. Trang sẽ thông báo hoặc hướng dẫn người dùng",
    tipsp6: "① Chỉ thông báo",
    tipsp7:
      "② Chuyển đến trang liên kết số điện thoại, sau khi hoàn thành sẽ quay lại",
    tipsp8:
      "③ Chuyển đến trang xác minh danh tính, sau khi hoàn thành sẽ quay lại",
    tipsp9:
      "④ Chuyển đến trang liên kết tài khoản, sau khi hoàn thành sẽ quay lại",
    tipsp10: "Rút tiền sẽ có phí, phí sẽ khác nhau tùy theo kênh rút tiền",

    tipsp11: "1. Tỷ lệ quy đổi: 1000 đậu vàng = 500 xu vàng",
    tipsp12: "2. Tối thiểu 5000 đậu vàng để đổi, phải là bội số của 1000",
    tipsp13:
      "3. Sau khi quy đổi thành công không thể hủy, vui lòng cân nhắc kỹ",

    num: "Số lượng",
    Custom: "Tùy chỉnh",
    PleaseEnter: "Vui lòng nhập",
    Redeem: "Đổi",
    SelectType: "Chọn loại",
    GoldBeans: "Đậu vàng",
    GoldCoin: "Xu",
    WithdrawalAmount: "Số tiền rút",
    PleaseNum: "Nhập số xu muốn rút",
    All: "Tất cả",
    Withdraw: "Rút tiền",

    Incomedetails: "Chi tiết thu nhập",
    Expensedetails: "Chi tiết chi tiêu",
    Nobeans: "Không có đậu vàng để đổi",

    balance: "Số dư",

    Record: "Lịch sử giao dịch",
    WithdrawalRecord: "Lịch sử rút tiền",
  },

  contactUs: {
    Officialcustomerservice: "Dịch vụ khách hàng chính thức",
    ContactUs: "Liên hệ chúng tôi",
    Issueofguild: "Vấn đề về Guild",
  },

  myInvitation: {
    MyGoldBeans: "Đậu vàng của tôi",
    Share: "Chia sẻ mời thêm bạn",
    CopyLink: "Sao chép liên kết",
    GoldCoinEarnedToday: "Xu nhận được hôm nay",
    TotalGoldCoin: "Tổng xu",
    tips: "Mời người dùng mới nạp tiền sẽ nhận được 1% xu thưởng",
    tips2: "Không thể liên kết sau 48 giờ đăng ký",
    MyInvitations: "Lời mời của tôi",
    BillingDetails: "Chi tiết hóa đơn",
    Total: "Tổng cộng",
    People: "người",
    GoldCoinGiven: "Xu đã tặng",
    GiveGoldCoin: "Tặng thêm+",
    InvitationLink: "Liên kết mời",
    ShareQR: "Chia sẻ mã QR",
    InviteCount: "Số người được mời",
    RevenueBeans: "Đậu vàng thu được",
    InvitationDetails: "Chi tiết mời",
    EarningsDetails: "Chi tiết thu nhập",
    NickNameLabel: "Biệt danh",
    SaveImage: "Lưu ảnh",
    QRScanHint: "Quét mã QR hoặc dùng liên kết mời để tham gia",
    ShareTagline: "Share & Chat & Live",
    GoldenBeanUnit: "đậu vàng",
    CommissionRate: "Hoa hồng {rate}%",
  },

  userMisconduct: {
    title1: "Vi phạm nội dung I",
    p1: "1. Hiển thị hoặc truyền bá nội dung bị cấm:",
    p2: "Bao gồm nội dung khiêu dâm, thô tục, bạo lực hoặc phân biệt chủng tộc trong chat riêng, live stream hoặc các tính năng khác của Rain Live.",
    p3: "2. Lan truyền phát ngôn thù địch:",
    p4: "Cấm phát ngôn thù địch về tôn giáo, chủng tộc, chính trị hoặc quốc tịch.",
    p5: "3. Quảng cáo hoặc lôi kéo:",
    p6: "Cấm mời người dùng tham gia các ứng dụng hoặc nền tảng khác thông qua live stream, chat riêng hoặc bình luận đã duyệt.",
    title2: "Hậu quả",
    p7: "Tài khoản, thiết bị hoặc địa chỉ IP liên quan đến vi phạm có thể bị cấm",

    title3: "Vi phạm nội dung II",
    p8: "1. Chia sẻ thông tin cá nhân:",
    p9: "Cấm chia sẻ thông tin cá nhân như số điện thoại, ID tài khoản, tài khoản Facebook, ảnh, v.v. thông qua live stream, bình luận hoặc chat riêng của Rain Live.",
    p10: "2. Lạm dụng tài khoản:",
    p11: "Cấm cung cấp, cho thuê hoặc bán tài khoản Rain Live.",
    p12: "3. Sử dụng thông tin cá nhân:",
    p13: "Cấm sử dụng hoặc phát tán thông tin cá nhân (ảnh, biệt danh, v.v.) của người dùng mà không được sự đồng ý để trục lợi hoặc tấn công ác ý",
    title4: "Hậu quả",
    p14: "Người dùng vi phạm sẽ bị cấm vĩnh viễn",
  },

  landingPage: {
    info1: "Cộng đồng Rain Live",
    info2: "Mua sắm nội bộ Apl",
    item1: "45K đánh giá",
    item2: "Tải xuống",
    item3: "Cấp độ 3+",
    btn: "Tải xuống",
    title: "Về Rain Live",
    content:
      "Rain Live là ứng dụng live stream thân thiện dành cho mọi người, bao gồm voice, video, giải trí, game, v.v. Nền tảng quy tụ các streamer xinh đẹp, là nền tảng live stream có chiều sâu và nội dung. PK gay cấn, sự kiện liên tục, quà tặng độc đáo, trải nghiệm đẳng cấp hoàng gia.",
    tips: "Rain Live đứng đầu danh sách ứng dụng xã hội miễn phí phổ biến.",
  },

  equityLevel: {
    Experience: "Điểm kinh nghiệm",
    Level: "Cấp độ hiện tại",
    Berikutnya: "Còn lại để lên cấp",
    title1: "Đặc quyền cấp độ",
    desc1:
      "Cấp độ càng cao, biểu tượng càng sang trọng, càng dễ được streamer yêu thích chú ý",
    title2: "Cách lên cấp",
    desc2:
      "1. Cấp độ người dùng phụ thuộc vào số điểm kinh nghiệm từ việc tặng quà",
    desc3:
      "2. Bạn có thể nhận điểm kinh nghiệm để lên cấp bằng cách tặng quà hàng ngày",
    desc4: "3. Quà may mắn, mỗi 1 xu tiêu = 1 điểm kinh nghiệm",
    desc5: "4. Quà đặc biệt, mỗi 1 xu tiêu = 10 điểm kinh nghiệm",
    title3: "Đặc quyền cấp độ",
    desc6:
      "Cấp độ càng cao, biểu tượng càng sang trọng, càng dễ được người dùng chú ý",
    title4: "Cách lên cấp",
    desc7:
      "1. Cấp độ streamer phụ thuộc vào số điểm kinh nghiệm từ việc nhận quà",
    desc8:
      "2. Bạn có thể nhận điểm kinh nghiệm để lên cấp thông qua số lượng quà nhận được hàng ngày",

    title6: "Cấp độ người dùng",
    title7: "Cấp độ",
    title8: "Huy hiệu cấp độ",
    title9: "Cấp độ streamer",
    title10: "Tổng điểm kinh nghiệm",

    LevelDescription: "Mô tả cấp độ",
    tabUser: "Người dùng",
    tabEx: "Ex xu",
    tabAnchor: "Streamer",
    titleOverview: "Tổng quan cấp độ tài phú",
    nickNameUser: "Biệt danh người dùng",
    nickNameAnchor: "Biệt danh streamer",
    nickNameEx: "Biệt danh người dùng",
    exPrivilegeDesc:
      "Cấp độ càng cao, biểu tượng càng sang trọng, càng dễ được người dùng chú ý",
    exDesc1: "1. Cấp Ex phụ thuộc vào số điểm kinh nghiệm từ việc tặng quà",
    exDesc2:
      "2. Bạn có thể nhận điểm kinh nghiệm để lên cấp bằng cách tặng quà hàng ngày",
    exDesc3: "3. Quà may mắn, mỗi 1 xu tiêu = 1 điểm kinh nghiệm",
    exDesc4: "4. Quà đặc biệt, mỗi 1 xu tiêu = 10 điểm kinh nghiệm",
    anchorPrivilegeDesc:
      "Cấp độ càng cao, biểu tượng càng sang trọng, càng dễ được người dùng chú ý",
    anchorDesc1:
      "1. Cấp độ streamer phụ thuộc vào số điểm kinh nghiệm từ việc nhận quà",
    anchorDesc2:
      "2. Bạn có thể nhận điểm kinh nghiệm để lên cấp thông qua số lượng quà nhận được hàng ngày",
  },

  applyJoin: {
    tips1: "Vui lòng nhập tài khoản WhatsApp của bạn",
    title2: "Yêu cầu ảnh",
    tips2: "Vui lòng chụp ảnh khuôn mặt và nửa thân trên, tạo dáng tay như mèo",
    tips3: "Ảnh này sẽ được sử dụng để công ty xét duyệt và sẽ được bảo mật.",
    tips4: "Ảnh phải là của chính bạn.",
    title3: "Yêu cầu video",
    tops5: "Video phải là của chính bạn.",
    tips6: "Thời lượng video từ 10 đến 20 giây.",
    status1: "Gửi xét duyệt",
    status2: "Đang xét duyệt",
    status3: "Xét duyệt thành công",
    status4: "Xét duyệt thất bại",
    LiveMode: "Chế độ live",
    Video: "Video",
    Voice: "Voice",

    MP4: "Vui lòng chọn video định dạng MP4",
    pngOrJpg: "Vui lòng tải lên ảnh định dạng PNG hoặc JPG",

    UploadingWait: "Đang tải lên, vui lòng đợi",
    CompleteInformation: "Vui lòng điền đầy đủ thông tin",
    TabPersonalStreamer: "Xác Minh Host",
    TabJoinGuild: "Tham gia guild",
    faceVerifyTitle: "Xác minh khuôn mặt",
    faceVerifyPending: "Chờ xác minh",
    faceVerifyVerified: "Đã xác minh",
    faceVerifyError: "Bạn đã xác minh tài khoản khác, không thể xác minh",
    faceVerifyRequired: "Vui lòng hoàn tất xác minh khuôn mặt trước",
    faceVerifyNotSupported:
      "Môi trường hiện tại không hỗ trợ xác minh khuôn mặt",
    faceVerifyStart: "Bắt đầu",
    faceVerifyRetry: "Thử lại",
    faceVerifySuccess: "Xác minh thành công",
    faceVerifyFail: "Xác minh thất bại",
  },

  cancelAccount: {
    title: "Yêu cầu xóa tài khoản",
    tips: "Những thông tin sau sẽ bị xóa và không thể khôi phục",
    p1: "Tất cả thông tin tài khoản sẽ bị xóa vĩnh viễn (bao gồm theo dõi, fan, v.v.), các dịch vụ giá trị gia tăng đã mua sẽ không được giữ lại và không thể chuyển cho tài khoản khác (VIP, ID đẹp, khung avatar, v.v.)",
    p2: "Tài khoản Facebook, Twitter, Apple, Google đã liên kết sẽ bị hủy liên kết, có thể đăng ký lại sau khi hủy liên kết",
    p3: "Thông tin streamer của bạn sẽ bị hủy liên kết, có thể liên kết lại với tài khoản khác sau khi hủy liên kết (nếu bạn là streamer, thông tin streamer có thể xác thực lại để phát sóng)",
    p4: "Sau khi xóa tài khoản, số dư xu, kim cương, điểm kinh nghiệm, xe, quý tộc và các dữ liệu thu nhập khác sẽ bị xóa, nếu phát sinh tổn thất lợi ích, người yêu cầu xóa tài khoản sẽ chịu trách nhiệm",
    p5: "Nếu bạn là trưởng guild, guild sẽ tự động giải tán sau khi gửi yêu cầu xóa tài khoản (không thể khôi phục guild sau khi giải tán dù hủy yêu cầu); nếu bạn là thành viên guild, bạn sẽ tự động rời guild sau khi xóa tài khoản (có thể khôi phục nếu hủy xóa trong thời gian khiếu nại 15 ngày)",
    p6: "Nếu bạn là trưởng gia tộc, bạn cần giải tán hoặc rời gia tộc trước khi gửi yêu cầu xóa tài khoản;",
    p7: "Nếu bạn là thành viên gia tộc (không phải trưởng), bạn sẽ tự động rời gia tộc khi gửi yêu cầu xóa tài khoản (không thể khôi phục nếu hủy xóa trong thời gian khiếu nại 15 ngày)",
    p8: "Sau khi gửi yêu cầu xóa, có thời gian khiếu nại 15 ngày. Đăng nhập trong thời gian này sẽ tự động hủy xóa. Sau khi hết hạn khiếu nại, tài khoản sẽ tự động bị xóa và không thể khôi phục. Nếu trong thời gian này có lý do như không phải bản thân hoặc thao tác nhầm để khôi phục tài khoản, vui lòng liên hệ CSKH để khiếu nại. (WhatsApp CSKH: +62 81188011180, hoặc email: rainlive888@gmail.com)",
  },

  Proxy: {
    Hello: "Xin chào,",
    Welcome: "Chào mừng đến Rain Chat!",
    Account: "Tài khoản",
    Pleaseenter: "Vui lòng nhập",
    Password: "Mật khẩu",
    Login: "Đăng nhập",
    MyAgent: "Đại lý của tôi",
    Nickname: "Biệt danh đại lý",
    CoinBalance: "Số dư xu đại lý",
    TransferRecord: "Lịch sử chuyển khoản",
    Recharge: "Nạp tiền",
    ExchangeProxyCoin: "Đổi xu đại lý",
    TransferInformation: "Vui lòng điền thông tin chuyển khoản",
    Reset: "Đặt lại",
    RecipientID: "ID người nhận",
    RecipientNickname: "Biệt danh người nhận",
    TransferAmount: "Số tiền chuyển",
    TotalTransferAmount: "Tổng cộng",
    Transfer: "Chuyển khoản",
    KindReminder: "Nhắc nhở",
    DoubleCheck: "Vui lòng kiểm tra lại thông tin",
    SelectAmount: "Vui lòng chọn số tiền nạp",
    SelectMonth: "Chọn tháng",
    Username: "Tên người dùng",
    TransferTime: "Thời gian chuyển khoản",
    AutoFill: "Tự động điền",
    Rechargeselection: "Lựa chọn nạp tiền",
    ProxyCurrency: "Không đủ xu đại lý",
    PaymentAmount: "Số tiền thanh toán",
    PleaseSelectAmount: "Vui lòng chọn số tiền nạp",
    GoldExchangeTitle: "Đổi đậu vàng lấy xu đại lý",
    GoldBalanceLabel: "Số dư đậu vàng: ",
    InputGoldPlaceholder: "Nhập đậu vàng",
    AvailableProxyCoin: "Xu đại lý có thể nhận",
    GiftProxyCoin: "Tặng {amount} xu đại lý",
    GiftBonusPercent: "Tặng {bonus}%",
    Exchange: "Đổi",
    Tip: "Nhắc nhở",
    ExchangeConfirmHtml:
      'Bạn sẽ dùng <span class="green">{gold}</span> đậu vàng để đổi lấy <span class="green">{coin}</span><br/>xu đại lý, kèm tặng <span class="orange">{gift}</span> xu đại lý.',
    ExchangeSuccessTitle: "Đổi thành công",
    ExchangeSuccessText: "Xu đại lý đã được ghi có, vui lòng kiểm tra.",
    ExchangeFail: "Đổi thất bại",
    RequestFail: "Yêu cầu thất bại",
  },

  bd: {
    incomeDetail: {
      title: "Chi tiết thu nhập",
      lastWeekIncome: "Thu nhập tuần trước",
      totalIncome: "Tổng thu nhập lịch sử",
      guildId: "ID Guild",
      date: "Ngày",
      thisWeek: "Tuần này",
      lastWeek: "Tuần trước",
      beforeLastWeek: "Tuần trước nữa",
      thisMonth: "Tháng này",
      lastMonth: "Tháng trước",
      summary: "Tổng hợp",
      guildName: "Tên guild",
      guildIncome: "Thu nhập guild",
      effectiveLive: "Phát sóng hiệu quả",
      myIncome: "Thu nhập của tôi",
      noData: "Không có dữ liệu",
      searching: "Tìm kiếm dữ liệu thu nhập",
      showingSummary: "Hiển thị dữ liệu tổng hợp",
    },
    index: {
      title: "BD",
      guildCount: "Số lượng guild",
      weekEstimatedIncome: "Thu nhập dự kiến tuần này",
      lastWeekIncome: "Thu nhập tuần trước",
      inviteCode: "Mã mời",
      searchPlaceholder: "Vui lòng nhập ID guild",
      lastWeek: "Tuần trước",
      guildName: "Tên guild",
      guildId: "ID Guild",
      weekIncome: "Thu nhập guild tuần này",
      myIncome: "Thu nhập của tôi",
      effectiveLive: "Phát sóng hiệu quả",
      bindDays: "Số ngày liên kết",
      copySuccess: "Đã sao chép mã mời",
      enterGuildId: "Vui lòng nhập ID guild",
      searchGuild: "Tìm kiếm ID guild",
      search: "Tìm kiếm",
      summary: "Tổng hợp",
      selectWeek: "Chọn chu kỳ",
      loading: "Đang tải...",
      loadFailed: "Tải thất bại",
      networkError: "Lỗi mạng, vui lòng thử lại sau",
    },
  },

  noble: {
    expireTime: "Thời gian hết hạn",
    canReceive: "Có thể nhận {coin} xu",
    receive: "Nhận ngay",
    received: "Đã nhận",
    becomeNoble: "Trở thành quý tộc",
    totalCanGet: "Tổng cộng có thể nhận {price}{totalCoin} xu",
    silver: "Bạc",
    gold: "Vàng",
    platinum: "Bạch kim",
    diamond: "Kim cương",
    obsidian: "Obsidian",
    type: "Quyền lợi",
    levelReward: "Mô tả",
    dailyExCoin: "Ex-Coin",
    rechargeReward: "Top up",
    gameSupport: "Game",
    exclusiveDecoration: "Trang phục",
    decoration: {
      profileCard: "Thẻ hồ sơ",
      bubble: "Bong bóng chat",
      vehicle: "Xe",
      avatarFrame: "Khung ảnh",
      badge: "Huy hiệu",
    },
    dailyFreeExCoin: "{amount} Ex-Coin miễn phí hàng ngày",
    monthlyRechargeBenefit:
      "{percent}% nạp hàng tháng làm quỹ quyền lợi, cấp vào tài khoản tháng sau.",
    monthlyGameConsumptionBenefit:
      "{percent}% vàng tiêu game hàng tháng, cấp vào tài khoản tháng sau.",
    privileges: {
      getCoin: "Nhận xu",
      avatarFrame: "Khung avatar",
      medal: "Huy hiệu",
      vehicle: "Phương tiện",
      purchaseNotification: "Thông báo mua",
      chatBubble: "Bong bóng chat",
      colorfulNickname: "Biệt danh màu sắc",
      specialId: "ID đặc biệt",
      mystery: "Người bí ẩn",
      exclusiveService: "Dịch vụ độc quyền",
      title: "Quyền lợi",
      Effect: "Hiệu Ứng Vào Phòng",
    },
    receiveSuccess: "Nhận thành công",
    contactOperation: "Vui lòng liên hệ vận hành để nhận",
    level1Recharge: "Quý tộc Bạc /30 ngày",
    level2Recharge: "Quý tộc Vàng /30 ngày",
    level3Recharge: "Quý tộc Bạch kim /30 ngày",
    level4Recharge: "Quý tộc Kim cương /30 ngày",
    level5Recharge: "Quý tộc Obsidian /30 ngày",
    vipCenterTitle: "Trung tâm Quý tộc",
    expireTimeText: "Hết hạn",
    openVip: "Nạp để mở",
    reachedLevel: "Đã đạt cấp độ",
    stillNeedCoins: "Cần thêm {amount} xu",
    stillNeedCoinsToKeepGrade: "Cần thêm {amount} xu để duy trì cấp",
    stillNeedCoinsToActivate: "Cần thêm {amount} xu để kích hoạt {levelName}",
    keepGradeCompleted: "Gia hạn",
    keepGradeProgress: "Tiến trình duy trì cấp: ",
    progress: "Tiến trình",
  },

  bonusActivity: {
    title: "Phần thưởng phát sóng bổ sung",
    activityTime: "Thời gian hoạt động: 7/4/2025 đến 4/5/2025 (UTC+8)",
    rewardRules: "Quy tắc phần thưởng",
    reward: "Phần thưởng",
    totalReceived: "Tổng đã nhận",
    bonus: "Tiền thưởng",
    claim: "Nhận",
    claimed: "Đã nhận",
    notAchieved: "Chưa đạt",
    duration: "Thời lượng (giờ)",
    target: "Mục tiêu (xu)",
    note: "Lưu ý: Sau khi đạt mục tiêu, tiền thưởng có thể nhận vào ngày hôm sau",
    activityCalendar: "Lịch hoạt động",
    april: "Tháng 4",
    may: "Tháng 5",
    claimSuccess: "Nhận thành công",
  },

  bonusActivityRule: {
    activityDescription: "Mô tả hoạt động",
    descriptionContent:
      "Ngoài phần thưởng cơ bản, người phát sóng sẽ nhận được phần thưởng bổ sung từ Rain Live.",
    activityTime: "Thời gian hoạt động",
    timeContent1: "7/4/2025 đến 4/5/2025 (UTC+8)",
    timeContent2:
      "Vào 0 giờ (UTC+8) mỗi ngày, phần thưởng của ngày tiếp theo sẽ được mở",
    claimMethod: "Phương thức nhận",
    claimContent:
      "Khi đạt mục tiêu trong ngày, có thể nhận thưởng thủ công vào ngày hôm sau.",
    rewardTable: "Bảng phần thưởng:",
    targetTurnover: "Mục tiêu doanh thu",
    activityReward: "Phần thưởng hoạt động",
  },

  inviteFriends: {
    invitationEventTitle: "Sự kiện mời",
    inviteAndEarnRewards: "Mời và nhận thưởng",
    eventPeriod: "Thời gian hoạt động: 7/4 00:00 - 4/5 23:59:59 (UTC+8)",
    invitationRecord: "Lịch sử mời",
    eventDetails: "Chi tiết sự kiện",
    week1DateRange: "Tuần 1: 7/4-13/4",
    totalInvitedExample: "Số người đã mời",
    level1RewardText: "Lv.1 Mời 20 người                   20000 xu",
    level2RewardText: "Lv.2 Mời 50 người                   50000 xu",
    level3RewardText: "Lv.3 Mời 100 người                 100000 xu",
    statusClaimed: "Đã nhận",
    actionClaim: "Nhận",
    statusNotAchieved: "Chưa đạt",
    topUpRewardsLabel: "Phần thưởng nạp tiền:",
    copyInvitationLink: "Sao chép liên kết mời",
    rewardNote:
      "Lưu ý: Khi người được mời nạp tiền, bạn sẽ nhận được 2% số xu tương ứng.",
    copySuccess: "Sao chép thành công",
    claimSuccessExample: "Nhận thành công 20000 xu",
    userIDLabel: "ID người dùng",
    userNameLabel: "Tên người dùng",
    timeLabel: "Thời gian",
    topUpLabel: "Nạp tiền",
    eventPurposeTitle: "【Mục đích sự kiện】",
    eventPurposeDesc:
      "Để cảm ơn sự ủng hộ và yêu thích lâu dài của người dùng dành cho Rain Live, nền tảng đặc biệt ra mắt sự kiện 'Mời bạn bè - Nhận nhiều quà tặng', mời bạn cùng bạn bè chia sẻ trải nghiệm phát sóng trực tiếp thú vị!",
    eventDurationTitle: "【Thời gian sự kiện】",
    eventDateRange: "7/4/2025 đến tháng 5/2025",
    eventCycleDesc:
      "Tổng cộng 4 tuần, phần thưởng chu kỳ mới sẽ mở vào 0 giờ (UTC+8) mỗi thứ Hai",
    rewardRulesTitle: "【Quy tắc phần thưởng】",
    rewardRulesDesc1:
      "Ngoài phần thưởng của sự kiện này, vẫn được hưởng phần thưởng mời ban đầu:",
    rewardRulesDesc2:
      "2% số xu nạp của người dùng sẽ được thưởng thêm cho người mời.",
    importantNotesTitle: "【Lưu ý quan trọng】",
    importantNotesDesc:
      "⚠️ Nghiêm cấm các hành vi gian lận phần thưởng thông qua tài khoản giả, đăng ký bằng máy, v.v. Khi phát hiện, tất cả phần thưởng sẽ bị thu hồi ngay lập tức và có thể bị hạn chế chức năng tài khoản;",
  },
  bonusPoints: {
    activityTime: "Thời gian hoạt động",
    resetTime: "Đặt lại hàng ngày lúc 00:00 (UTC+8)",
    pointsReward: "Thưởng điểm",
    coinsReward: "Thưởng vàng",
    participationTimes: "Tham gia {times} lần",
    points: "Điểm",
    exchange: "Đổi",
    pointsMall: "Cửa hàng điểm",
    betSum: "Tổng cược hiện tại",
    note: "Ghi chú",
    rule1: "1.Điểm thu được khi hoàn thành nhiệm vụ hàng ngày.",
    rule2: "2.Phần thưởng trong trung tâm điểm thay đổi không định kỳ.",
    rule3: "3.Sau khi đổi, điểm không trả lại. Đổi cẩn thận.",
    coins: "Vàng",
    claim: "Nhận",
    claimed: "Đã nhận",
    notAchieved: "Chưa đạt",
    reach: "Đạt",
  },
  gameRanking: {
    notRanked: "Không Xếp Hạng",
    distanceToRank: "Còn thiếu {points} điểm để đạt xếp hạng 50",
    distanceToBeforeRank: "Còn thiếu {points} điểm để đạt xếp hạng {rankId}",
    rank1: "Bạn đã ở vị trí đầu tiên",
    today: "Hôm nay",
    yesterday: "Hôm qua",
    ruleBtn: "Rule",
    rules: {
      pointsStats: {
        title: "Quy Tắc Thống Kê Điểm",
        conversion:
          "1. Tiêu Chuẩn Chuyển Đổi Điểm：1 đồng xu tương đương với 1 điểm trong hoạt động, và điểm của người tham gia sẽ được tính trực tiếp dựa trên số lượng đồng xu.",
        timeRange:
          "2. Khoảng Thời Gian Thống Kê：Chu kỳ thống kê điểm hàng ngày là 00:00 đến 23:59 (Múi Giờ UTC+8), dữ liệu đồng xu vượt quá khoảng thời gian này sẽ được đưa vào thống kê ngày hôm sau.",
      },
      ranking: {
        title: "Quy Tắc Xếp Hạng và Thưởng",
        basis:
          "3. Cơ Sở Xếp Hạng：Hệ thống sẽ xếp hạng người tham gia theo thứ tự giảm dần dựa trên tổng điểm cuối cùng hàng ngày của họ (tức là tổng số đồng xu trong ngày đó) để xác định xếp hạng hàng ngày.",
        rewards: "4. Cấu Hình Thưởng：",
        reward1: "Xếp hạng 1: Thưởng 250.000 đồng xu",
        reward2: "Xếp hạng 2: Thưởng 150.000 đồng xu",
        reward3: "Xếp hạng 3: Thưởng 100.000 đồng xu",
        reward4: "Xếp hạng 4: Thưởng 50.000 đồng xu",
        reward5: "Xếp hạng 5: Thưởng 50.000 đồng xu",
      },
      distribution: {
        title: "Quy Tắc Phát Thưởng",
        description:
          "Thưởng tương ứng với xếp hạng hàng ngày sẽ được phát một cách thống nhất vào ngày hôm sau. Người tham gia có thể đăng nhập vào trang hoạt động hoặc tài khoản cá nhân vào ngày hôm sau để kiểm tra trạng thái nhận thưởng.",
      },
      pointsCalculation: {
        description:
          "Doanh thu Game tối thiểu 5.000.000 là điều kiện cần thiết để nhận được phần thưởng của sự kiện.",
      },
      helpReward: {
        description:
          "Thưởng Bổ Sung: Nếu đáp ứng các yêu cầu tương ứng nhưng không nhận được thưởng xếp hạng, sẽ nhận được thưởng bổ sung.",
      },
      turnoverRewards: {
        title: "Quy Tắc Thưởng Doanh Thu",
        turnover: "Doanh Thu",
        reward: "Thưởng",
        turnover1M: "1,000,000",
        reward10K: "10,000 Đồng Xu",
        turnover3M: "3,000,000",
        reward30K: "30,000 Đồng Xu",
        turnover5M: "5,000,000",
        reward50K: "50,000 Đồng Xu",
      },
      violation: {
        title: "Quy Tắc Vi Phạm và Trừng Phạt",
        description:
          "Trong thời gian diễn ra hoạt động, nghiêm cấm người tham gia sử dụng lỗ hổng hệ thống, phần mềm gian lận hoặc bất kỳ phương tiện nào để gian lận bằng cách 刷取 (刷取) điểm (đồng xu). Nếu bị phát hiện:",
        penalty1:
          "5. Người vi phạm lần đầu sẽ bị thu hồi đủ điều kiện nhận thưởng trong ngày;",
        penalty2:
          "6. Người vi phạm với tình huống nghiêm trọng hoặc lặp đi lặp lại sẽ bị cấm trực tiếp tham gia hoạt động này và các hoạt động liên quan tiếp theo, và quyền tham gia sẽ không được khôi phục.",
      },
    },
  },
  luckyAnchorRanking: {
    today: "Hôm nay",
    yesterday: "Hôm qua",
    notRanked: "Chưa xếp hạng",
    distanceToRank: "Cần thêm {points} đậu may mắn để vào top 50",
    distanceToBeforeRank: "Cần thêm {points} đậu may mắn để đạt hạng {rankId}",
    rank1: "Bạn đã là hạng 1",
    rules: {
      activity: {
        title: "Mô tả hoạt động",
        description:
          "Thống kê thu nhập đậu may mắn hàng ngày của streamer và xếp hạng dựa trên thu nhập này.",
      },
      ranking: {
        title: "Phần thưởng xếp hạng",
        rank: "Hạng",
        reward: "Phần thưởng đậu",
        decoration: "Trang trí",
        frameAndBubble: "Khung avatar + Bong bóng",
        frameOnly: "Khung avatar",
        requirement:
          "Yêu cầu tối thiểu cho phần thưởng xếp hạng: 150,000 thu nhập đậu may mắn.",
      },
      helpReward: {
        title: "Phần thưởng hỗ trợ",
        description:
          "Người dùng không nhận được phần thưởng xếp hạng cũng có thể nhận phần thưởng mục tiêu thu nhập đậu may mắn.",
        target: "Mục tiêu",
        reward: "Phần thưởng",
      },
      distribution: {
        title: "Phân phối phần thưởng",
        description: "Phần thưởng sẽ được phân phối vào ngày hôm sau.",
      },
      statistics: {
        title: "Mô tả thống kê",
        description: "Thống kê dựa trên thu nhập đậu may mắn.",
      },
    },
  },

  // Hoạt động Red Envelope Rain
  redEnvelopeRain: {
    countdownTitle: "Đếm ngược nhận xu",
    startNow: "Bắt đầu ngay",
    rules: "Quy tắc",
    timeSlotPrize: "Giải thưởng tham gia theo khung giờ",
    winningDetails: "Chi tiết trúng thưởng",
    activityRules: "Quy tắc hoạt động",
    congratulations: "Chúc mừng bạn trúng thưởng",
    sorryNoWin: "Rất tiếc, bạn không trúng thưởng",
    coin: "Xu",
    rulesContent: {
      rule1:
        "i. Lì xì sẽ được mở đúng 20:00 mỗi ngày, sau đó cứ mỗi 20 phút lại diễn ra một lần.",
      rule2:
        "ii. Trước khi nhận lì xì, cần phát biểu 3 lần trong phòng livestream.",
      rule3: "iii. Thời gian diễn ra sự kiện: từ ngày 18/10 đến 17/11.",
      rule4:
        "iv. Nếu phát hiện hành vi cố tình lấy vàng bất hợp pháp, nền tảng sẽ tiến hành xử lý khóa tài khoản.",
      rule5: "",
    },
    timeStatus: {
      inProgress: "Đang diễn ra",
      notStarted: "Chưa bắt đầu",
      finished: "Đã kết thúc",
    },
    chatRequirement:
      "Gửi 3 tin nhắn trong phòng live để nhận, tin nhắn hiện tại: {count}",
  },

  // Hoạt động Guild
  guildActivity: {
    ruleBtn: "Rule",
    tabThis: "THIS",
    tabLast: "LAST",
    activityRules: "Quy tắc hoạt động",
    rulesContent: {
      activityTime: "Thời gian hoạt động: Bắt đầu từ 29/9",
      rankingRewards: "Phần thưởng xếp hạng",
      requirements: "Yêu cầu",
      rewardDistribution: "Phân phối phần thưởng",
      rewardList: {
        first: "Hạng 1: 1.000.000 Hạt Vàng",
        second: "Hạng 2: 500.000 Hạt Vàng",
        thirdToFifth: "Hạng 3-5: 250.000 Hạt Vàng",
        sixthToTenth: "Hạng 6-10: 100.000 Hạt Vàng",
        eleventhToTwentieth: "Hạng 11-20: 50.000 Hạt Vàng",
      },
      requirementText:
        "Host guild phải hoàn thành ít nhất 30 buổi phát sóng trực tiếp mỗi tuần. Mỗi host phát sóng hơn 2 giờ mỗi ngày được tính là một buổi",
      distributionText: "Phần thưởng sẽ được phân phối vào tuần thứ hai",
    },
  },

  // Bảng xếp hạng sức hấp dẫn/Tiêu dùng
  charmRanking: {
    charmRanking: "Bảng Sức Hấp Dẫn",
    consumptionRanking: "Bảng Tiêu Dùng",
    dailyRanking: "Bảng Ngày",
    weeklyRanking: "Bảng Tuần",
    userNickname: "Tên người dùng",
    distanceToPrevious: "Khoảng cách đến người trước",
    noRankingData: "Không có dữ liệu xếp hạng",
    requestFailed: "Yêu cầu thất bại",
  },

  // Hoạt động mời bạn bè mới
  inviteActivity: {
    title: "Mời 3 người chắc chắn nhận được phần thưởng",
    rule: "Quy tắc",
    alreadyJoined: "Đã tham gia",
    inviteImmediately: "Mời ngay",
    callNumber: "Mời",
    myRewards: "Phần thưởng của tôi",
    claim: "Nhận",
    claimed: "Đã nhận",
    people: "Người",
    inviteFriends: "Mời bạn bè",
    processTitle: "Quy trình mời:",
    step1: "1. Gửi liên kết cho bạn bè",
    step2: "2. Bạn bè tải xuống và đăng ký",
    step3: "3. Nhận xu miễn phí",
    rulesTitle: "Quy tắc mời",
    rulesContent: {
      rule1: "Khi mời được 3 người, có thể nhận 16666 hạt vàng",
      rule2: "Khi mời được 25 người, có thể nhận thêm 36666 hạt vàng",
      rule3:
        "Khi mời được 100 người, có thể nhận thêm 88888 hạt vàng. Tổng có thể nhận: 142220 hạt vàng.",
      rule4: "Phần thưởng được nhận thủ công tại trang hoạt động.",
      rule5:
        "Nghiêm cấm gian lận số lượng người mời, nếu phát hiện sẽ bị khóa tài khoản",
    },
    close: "Đóng",
    inviteFeatureComingSoon: "Tính năng mời sẽ sớm có sẵn",
    rewardReceived: "Đã nhận thành công {amount} xu!",
  },

  // Trang Tặng Xu Vàng
  giftGoldCoins: {
    maxGiftableCoins: "Số Xu Vàng Tối Đa Có Thể Tặng",
    giftAmount: "Số Lượng Xu Vàng Tặng",
    customAmount: "Số Lượng Xu Vàng Tặng Tùy Chỉnh",
    enterAmount: "Nhập số lượng",
    quantity: "Số lượng",
    giftToOtherAccounts: "Tặng cho Tài Khoản Khác",
    exceedMaxAmount: "Số lượng không được vượt quá mức tối đa có thể tặng",
    amountSet: "Đã đặt số lượng thành công",
    invalidAmount: "Vui lòng nhập số lượng hợp lệ",
    selectValidAmount: "Vui lòng chọn số lượng hợp lệ",
    confirmTitle: "Xác Nhận Tặng",
    confirmMessage: "Bạn có chắc chắn muốn tặng {amount} xu không?",
    giftSuccess: "Tặng thành công",
    giftId: "ID Tặng",
    enterGiftId: "Nhập ID",
    pleaseEnterGiftId: "Vui lòng nhập ID tặng",
    giftCompleted: "Tặng thành công!",
    giftedToId: "Tặng cho ID",
    networkError: "Lỗi mạng, vui lòng thử lại sau",
    confirm: "Xác Nhận",
  },

  // Cửa hàng trang trí
  shop: {
    headerTitle: "Trang trí cá nhân",
    back: "Quay lại",
    shoppingBag: "Túi mua sắm",
    loading: "Đang tải...",
    noProducts: "Không có sản phẩm",
    unnamedProduct: "Sản phẩm chưa đặt tên",
    day: "Ngày",
    myCoins: "Xu của tôi",
    exchangeNow: "Đổi ngay",
    notSelected: "Chưa chọn",
    loginExpired: "Đăng nhập hết hạn, vui lòng đăng nhập lại",
    categoryNotExists: "Danh mục không tồn tại",
    loadFailed: "Tải thất bại",
    loadFailedRetry: "Tải thất bại, vui lòng thử lại",
    pleaseSelectProduct: "Vui lòng chọn sản phẩm trước",
    productNotExists: "Sản phẩm không tồn tại",
    insufficientCoins: "Xu không đủ, cần {amount} xu",
    exchangeSuccess: "Đổi thành công",
    exchangeFailed: "Đổi thất bại",
    categories: {
      hot: "Nổi bật",
      avatarFrame: "Khung avatar",
      entryEffect: "Hiệu ứng vào",
      chatBubble: "Bong bóng chat",
      mount: "Phương tiện",
    },
    recharge: "Nạp tiền >",
    validityPeriod: "Thời hạn:",
    myCoinsLabel: "Xu của tôi:",
  },
  myDecoration: {
    headerTitle: "Trang trí của tôi",
    back: "Quay lại",
    noWearingDecoration: "Không có trang trí nào được chọn",
    loading: "Đang tải...",
    noDecoration: "Không có trang trí",
    unnamedDecoration: "Trang trí chưa đặt tên",
    permanent: "Vĩnh viễn",
    wearing: "Đang sử dụng",
    pleaseSelectDecoration: "Vui lòng chọn trang trí",
    removeDecoration: "Gỡ trang trí",
    wearNow: "Sử dụng ngay",
    pleaseSelectDecorationFirst: "Vui lòng chọn trang trí trước",
    decorationNotExists: "Trang trí không tồn tại",
    loginExpired: "Đăng nhập hết hạn, vui lòng đăng nhập lại",
    loadFailed: "Tải thất bại",
    loadFailedRetry: "Tải thất bại, vui lòng thử lại",
    wearSuccess: "Sử dụng thành công",
    wearFailed: "Sử dụng thất bại",
    previewAnimation: "Xem trước",
    categories: {
      hot: "Hot",
      avatarFrame: "Khung avatar",
      entryEffect: "Hiệu ứng vào",
      chatBubble: "Bong bóng chat",
      mount: "Phương tiện",
    },
  },
  // Hoạt động Giáng sinh/Ngôi sao may mắn
  christmasActivity: {
    dailyLuckyStar: "Ngôi sao may mắn ngày",
    weeklyLuckyStar: "Ngôi sao may mắn tuần",
    startTime: "Thời gian bắt đầu:",
    obtainedCount: "Số lượng nhận được",
    moreChance: "Càng nhiều, càng lớn cơ hội",
    participated: "Met",
    notParticipated: "Unmet",
    historyRecord: "Lịch sử",
    myRecord: "Lịch sử của tôi",
    noRecord: "Không có lịch sử",
    loading: "Đang tải...",
    noMore: "Không còn nữa",
    coin: "Xu",
    goldCoin: "Vàng",
    unit: "cái",
    notWon: "Chưa trúng thưởng",
    conditionNotMet: "Điều kiện chưa đáp ứng",
    claimSuccess: "Nhận thành công",
    getRecordFailed: "Lấy lịch sử thất bại",
    rules: {
      title: "Quy định hoạt động",
      rule1: "Ngôi sao may mắn ngày",
      rule2:
        "Hoạt động Ngôi sao may mắn ngày, tất cả người dùng đều có thể tham gia",
      rule3:
        "Khi tặng quà tương ứng cho tươi, số lượng quà tặng sẽ được bằng dẫn, khi sử làng quê tông đạt yêu cầu, người dùng có thể tham gia mà & ai quay thong, mỗi lần sẽ có nghĩời may mắn nhận được phần thường xu vùng",
      rule4: "Số lượng quả bịng càng nhiều thì cơ hội trúng thường căng cao",
      rule5: "Ngôi sao may mắn tuần",
      rule6: "Hoạt động Ngôi sao mày màn tuân, tất cả khởi đầu có thể tham gia",
      rule7:
        "Khi nhịn được quả tương ứng do người dùng tụng, số lượng quân sự được cộng đồn, khi số lượng qua nhịn được địt yêu cầu, đợi có thì tham gần mẹ là xi Ngôi sao may min tuần, mài lần sự nó người may mẫn nhịn được phần thương",
      rule8:
        "Số lượng quà nhân được công nhiều thì cơ hội trúng thường công của",
      rule9: "Quy định khác",
      rule10: "Chương trình ăn này là đợt tri ân phúc lợi lớn",
      rule11: "Chỉ áp dụng cộng dồn khi tông qua cho khọi khác",
      rule12: "Nghiêm cấm m dang",
      rule13:
        "Phần thường sẽ được tự động phát theo từng khung giờ, có thể kiểm tra lịch sử trùng thường để biết kết quả",
    },
  },
  // Hoạt động Xếp hạng Điểm Ngôi sao May mắn
  fortuneStarActivity: {
    points: "Điểm",
    pointsRanking: "Xếp hạng Điểm",
    currentRoundPoints: "Điểm Vòng này",
    lastRoundPoints: "Điểm Vòng trước",
    defaultUserName: "Tên Người dùng",
    noData: "Không có dữ liệu",
    activityRules: "Quy tắc",
    historyRecord: "Lịch sử",
    earnedPoints: "Điểm đã nhận",
    participated: "Đã tham gia",
    notParticipated: "Chưa đáp ứng",
    myRecord: "Lịch sử của tôi",
    userId: "ID",
    userNickname: "Tên người dùng",
    sessionTime: "Thời gian phiên",
    winningStatus: "Tình trạng trúng thưởng",
    won: "Đã trúng thưởng",
    notWon: "Chưa trúng thưởng",
    rules: {
      rule1:
        "Trong thời gian sự kiện, người dùng có thể kiếm điểm bằng cách gửi quà tặng được chỉ định",
      rule2:
        "Điểm được tích lũy theo thời gian thực, kiểm tra xếp hạng điểm hiện tại",
      rule3:
        "Sau khi sự kiện kết thúc, người dùng xếp hạng cao sẽ nhận được phần thưởng hậu hĩnh",
      rule4:
        "Nghiêm cấm sử dụng bất kỳ thủ đoạn gian lận nào để kiếm điểm, người vi phạm sẽ bị hủy tư cách",
      rule5: "Nền tảng giữ quyền giải thích cuối cùng",
    },
  },

  // Hoạt động Hộp Bí Mật
  blindBox: {
    title: "Giới thiệu cách chơi",
    ruleTitle: "Giới thiệu cách chơi",
    rule1:
      "Mỗi {price} xu vàng có thể mở 1 {text}, sau khi mở, người chơi sẽ nhận ngẫu nhiên các loại quà tặng khác nhau, quà sẽ tự động được đưa vào túi.",
    rule2:
      "Có thể lấy quà nhận được từ trong túi tặng cho streamer mong muốn, streamer sẽ nhận được số đậu vàng tương ứng với quà đó",
    rewardTip: "Gợi ý phần thưởng",
    probabilityDesc: "Xác suất cụ thể như sau:",
    prize: "Phần thưởng",
    probability: "Xác suất",
    value: "Giá trị",
  },

  taskHub: {
    tabCenter: "Task Center",
    tabAnchor: "Host Tasks",
    signTitle: "7-day Check-in",
    signStreakBefore: "Consecutive check-in ",
    signStreakAfter: " days",
    signBtn: "Check in",
    signBtnDone: "Checked in",
    signPeriod: "This period: {start} - {end}",
    dayLabel: "Day{n}",
    avatarFrame: "Avatar frame",
    activeTasks: "User activity tasks",
    timeLeft: "Time left: {t}",
    claimable: "Claim",
    inProgress: "In progress",
    rewardGain: "Earn {n} EX coins",
    taskWatchLive: "Watch live for 30 minutes",
    taskFollowHosts: "Follow 3 hosts",
    taskSpeakRooms: "Speak 3 times in different rooms",
    taskGiftCoins: "Spend 100 coins on gifts",
    taskGameCoins: "Spend 100 coins on games",
    taskRechargeToday: "Recharge once today",
    unitMinutes: " min",
    unitHosts: " hosts",
    unitTimes: " times",
    unitCoins: " coins",
    unitDays: " days",
    toastSigned: "Checked in",
    toastClaimed: "Claimed",
    claimSuccessTitle: "Claim Successful",
    claimSuccessOk: "Got it",
    toastInProgress: "Task in progress",
    toastLoadFail: "Failed to load",
    claimed: "Completed",
    toastRefreshed: "Refreshed",
    anchorActivity: "Activity",
    weekDurationTitle: "Weekly duration",
    activityPeriod: "Activity period",
    weekLiveDuration: "Live duration this week",
    weekRank: "Weekly rank",
    claimableReward: "Claimable reward",
    effectExtraTitle: "Special effect bonus",
    effectBeansToday: "Effect beans received today",
    rewardDate: "Reward date {date}",
    claimableAmount: "Claimable",
    claimNow: "Claim now",
    claimedToday: "Claimed today:",
    effectNote: "Note: claim today's rewards before 1:00 (UTC+8) the next day.",
    todayData: "Today Data",
    todayLiveDuration: "Today's live duration",
    liveHintShort: "{remain} left",
    needMoreBeans: "{n} more needed",
    toastNoClaimable: "No reward available to claim",
    toastClaimPending: "Claim API pending integration",
    luckyBeans: "Lucky beans",
    nextDayLucky: "Next-day lucky reward",
    upgradeBeansTitle: "Upgrade to claim beans",
    upgradeReward: "Upgrade reward",
    weekData: "Week Data",
    totalLiveDuration: "Total live duration",
    validDays: "Valid days",
    weekLuckyReward: "Weekly lucky reward",
    dayDataTitle: "Today Data",
    monthDataTitle: "Month Data",
    weekDataTitle: "Week Data",
    monthLiveDuration: "Monthly live duration",
    weekLiveDuration: "Weekly live duration",
    specialBeans: "Special beans",
    totalBeans: "Total beans",
  },

  pcOfficial: {
    navHome: "Trang chủ",
    navLive: "Phát trực tiếp",
    navGameHall: "Sảnh game",
    received: "đã nhận",
    heroTagline: "Nền tảng giải trí Web4 hàng đầu toàn cầu",
    heroTaglineSub:
      "Tương tác thời gian thực 24/7 cùng các streamer hàng đầu, trải nghiệm game blockchain đỉnh cao. Dựa trên công nghệ phi tập trung, đảm bảo thưởng tức thì cho từng giao dịch, công bằng và minh bạch.",
    downloadNow: "Tải ngay",
    giftCoin: "Xu EX",
    giftAvatarFrame: "Avatar",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "Đề xuất streamer nổi bật",
    recommendSub:
      "Tương tác thời gian thực với hàng nghìn streamer và tận hưởng sức hút game P2E",
    hotGamingTitle: "Game nổi bật",
    hotGamingSub:
      "Người chơi thật, bảng xếp hạng thật. Bạn có trở thành huyền thoại tiếp theo không?",
    casinoTitle: "Sòng bài",
    casinoDesc1: "Tham gia cùng dealer thật với Baccarat,",
    casinoDesc2: "Roulette và Blackjack chuẩn HD",
    slotsTitle: "Slot",
    slotsDesc: "Trải nghiệm hàng trăm game slot chất lượng cao với RTP 98.5%",
    gamingTitle: "Game",
    gamingDesc: "Không chỉ quay thưởng, còn có game kỹ năng nhiều người chơi",
    whyTitle: "Vì sao chọn Rain Live",
    whyItem1Title: "Công bằng & minh bạch",
    whyItem1Desc: "RNG được kiểm định, đảm bảo tính công bằng",
    whyItem2Title: "Thanh toán tức thì",
    whyItem2Desc: "Rút tiền nhanh, nhận thưởng tức thời",
    whyItem3Title: "Ẩn danh & riêng tư",
    whyItem3Desc: "Bảo mật 100%, không yêu cầu thông tin cá nhân",
    whyItem4Title: "Phi tập trung",
    whyItem4Desc: "Trò chơi on-chain an toàn, minh bạch",
    terms: "Điều khoản dịch vụ",
    privacy: "Chính sách quyền riêng tư",
    navRecharge: "Nạp tiền",
    rechargeAccountTitle: "Tài khoản nạp",
    idLogin: "Đăng nhập ID",
    accountIdLabel: "ID tài khoản:",
    accountIdPlaceholder: "Nhập ID tài khoản",
    confirm: "Xác nhận",
    defaultUserName: "Tên người dùng",
    userIdWithValue: "ID:{id}",
    switchAccount: "Đổi tài khoản",
    rechargeQuantityTitle: "Số lượng nạp",
    goToPay: "Thanh toán",
    topUpAmountTitle: "Số tiền nạp",
    pay: "Thanh toán",
    channelDefault: "Kênh thanh toán",
    toastInvalidAccountId: "Vui lòng nhập ID tài khoản hợp lệ",
    toastNoTokenAfterLogin: "Đăng nhập thành công nhưng không nhận được token",
    toastLoginFailed: "Đăng nhập thất bại",
    toastCoinPackagesFailed: "Không tải được danh sách gói xu",
    toastPayChannelsFailed: "Không tải được kênh thanh toán",
    toastOrderParamsMissing: "Thiếu tham số đơn hàng, không thể thanh toán",
    toastNoPayUrl: "Không có địa chỉ thanh toán",
    toastCreateOrderFailed: "Tạo đơn thanh toán thất bại",
    rainLiveRecharge: "Rain Live Nạp tiền",
    selectCountryTitle: "Chọn quốc gia / khu vực",
    selectChannelTitle: "Chọn phương thức thanh toán",
    rechargeLoading: "Đang tải...",
    rechargePackagesEmpty: "Chưa có gói nạp",
    rechargeLoginHint: "Vui lòng đăng nhập bằng ID trước",
  },

  liveDuration: {
    tabthisWeek: "This  Week",
    tablastWeek: " Last Week",
    eventTime: "Thời gian sự kiện: {time}",
    rewardCoin: "Xu thưởng",
    liveHours: "Thời lượng phát trực tiếp",
    myRank: "Hạng của tôi",
    zeroHours: "0 giờ",
    hoursOnly: "{hours} giờ",
    minutesOnly: "{minutes} phút",
    hoursMinutes: "{hours} giờ {minutes} phút",
  },

  // Trang thanh toán đơn nạp USDT
  topUpUsdt: {
    orderNo: "Số đơn hàng",
    copy: "Sao chép",
    copyOrderNo: "Sao chép số đơn hàng",
    copyAddress: "Sao chép địa chỉ nhận",
    productName: "Xu vàng RainChat",
    quantityUnit: "× {count}",
    orderAmount: "Số tiền đơn hàng",
    scanToPay: "Quét để thanh toán",
    scanTip: "Dùng ứng dụng ví quét mã QR để thanh toán",
    qrAreaAlt: "Khu vực mã QR thanh toán",
    qrCodeAlt: "Mã QR thanh toán",
    receivingAddress: "Địa chỉ nhận",
    validityPrefix: "Hiệu lực",
    validityMinutes: "{minutes} phút",
    validitySuffix: ", vui lòng thanh toán sớm",
    orderNoCopied: "Đã sao chép số đơn hàng",
    addressCopied: "Đã sao chép địa chỉ nhận",
    nothingToCopy: "Không có nội dung để sao chép",
    copyFailed: "Sao chép thất bại, vui lòng sao chép thủ công",
    promptTitle: "Thông báo",
    rechargePrompt: "Nếu bạn đã nạp tiền, vui lòng nhấn Hoàn tất nạp tiền",
    cancel: "Hủy",
    completeRecharge: "Hoàn tất nạp tiền",
    rechargeCompleted: "✔ Nạp tiền hoàn tất",
    rechargeCompletedText: "Nạp tiền hoàn tất",
    rechargePending:
      "Hiện chưa nhận được thanh toán, có thể có độ trễ. Xu sẽ được tự động cộng sau khi thanh toán đến.",
    gotIt: "Đã hiểu",
  },

  rainChatOfficial: {
    appNotDetected: "Không phát hiện ứng dụng. Vui lòng tải xuống.",
  },

  // Sự kiện vòng quay may mắn xu trải nghiệm
  luckyTurntable: {
    draw: "Quay thưởng",
    drawing: "Đang quay",
    task: "Nhiệm vụ",
    recharge: "Nạp tiền",
    historyRecord: "Lịch sử",
    balanceLabel: "Số dư Xu trải nghiệm: ",
    exGradeTip: "Cấp Ex Lv.{grade} · Cần Lv.{level} để tham gia",
    got: "nhận được",
    defaultNotice: "Biệt danh người dùng {got} Xu trải nghiệm",
    insufficientBalance: "Số dư không đủ",
    exGradeNotMet: "Cấp Ex không đạt",
    configLoadFailed: "Tải cấu hình thất bại, vui lòng thử lại sau",
    recordLoadFailed: "Tải lịch sử thất bại, vui lòng thử lại sau",
    drawResultError: "Kết quả quay thưởng bất thường, vui lòng thử lại sau",
    drawFailed: "Quay thưởng thất bại, vui lòng thử lại sau",
    winTitle: "Chúc mừng! Bạn nhận được",
    winConfirm: "Đã hiểu",
    loading: "Đang tải...",
    noRecord: "Chưa có lịch sử",
    noMore: "Không còn nữa",
  },

  rewardActivity: {
    moreReward: "More",
    tabInvite: "Mời hoạt động",
    tabWelfare: "Phúc lợi 7 ngày",
    tabMic: "Thưởng lên mic",
    inviteTitle: "Thưởng mời người dùng hoạt động",
    yesterdayData: "Dữ liệu hôm qua",
    yesterdayActive: "Số người hoạt động hôm qua",
    goldBean: "Kim đậu",
    todayDataRealtime: "Dữ liệu hôm nay (thời gian thực)",
    todayActive: "Số người hoạt động hôm nay",
    peopleUnit: "người",
    estimateReward: "Thưởng dự kiến",
    claimTomorrowTip: "Nhận vào 10:00 ngày hôm sau",
    claimAt10: "10 giờ có thể nhận",
    claimYesterday: "Nhận thưởng hôm qua",
    claimed: "Đã nhận",
    noReward: "Chưa có thưởng",
    viewDetail: "Xem chi tiết",
    welfareTitle: "Phúc lợi 7 ngày host mới",
    personalNewHost: "Host mới cá nhân",
    rule: "Luật",
    welfareRemain: "Thời gian phúc lợi còn lại",
    dayUnit: "ngày",
    minuteUnit: "phút",
    day1: "Ngày 1",
    day7: "Ngày 7",
    todayData: "Dữ liệu hôm nay",
    todayMicDuration: "Thời gian lên mic hôm nay",
    claimableBean: "Kim đậu có thể nhận",
    claimReward: "Nhận thưởng",
    claimTodayReward: "Nhận thưởng hôm nay",
    todayCanClaim: "Hôm nay còn nhận {amount}",
    needMic60: "Lên mic 60 phút hôm nay để nhận",
    needMic120: "Lên mic 120 phút hôm nay để nhận",
    todayClaimedAll: "Đã nhận hết thưởng hôm nay",
    becomeAnchor: "Trở thành host để nhận thưởng",
    totalClaimed: "Tổng kim đậu đã nhận",
    welfareRulesTitle: "Quy Tắc Ưu Đãi 7 Ngày",
    welfareCondTitle: "1. Điều kiện tham gia:",
    welfareCond1: "a. Người dùng mới trong vòng 7 ngày kể từ khi đăng ký",
    welfareCond2: "b. Hoàn thành xác minh Host",
    welfareCond3: "c. Chưa gia nhập Agency",
    welfareRewardTitle: "2. Chi tiết phần thưởng",
    welfareReward1: "a. Mỗi ngày lên mic và mở mic sẽ tích lũy thời lượng.",
    welfareReward2: "b. Mỗi 1 giờ, bạn có thể nhận 5.000 Gold Beans.",
    welfareReward3: "c. Mỗi ngày tối đa có thể nhận 2 giờ, 10.000 Gold Beans.",
    welfareReward4: "d. Tối đa có thể nhận 70.000 Gold Beans.",
    welfareNoteTitle: "3. Lưu ý",
    welfareNote1: "a. Phần thưởng phải được nhận thủ công mỗi ngày",
    welfareNote2:
      "b. Nếu thời gian đăng ký vượt quá 7 ngày, bạn sẽ không thể nhận lại.",
    welfareNote3: "c. Dữ liệu được cập nhật mỗi 10-15 phút",
    welfareNote4:
      "d. Nếu phát hiện dùng thủ đoạn gian lận để trục lợi phần thưởng, tài khoản sẽ bị khóa.",
    micRulesTitle: "Quy Tắc Thưởng Khi Lên Mic",
    micCondTitle: "1. Điều kiện tham gia:",
    micCond1: "a. Hoàn thành xác minh Host",
    micCond2: "b. Chưa gia nhập Agency.",
    micRewardTitle: "2. Phần thưởng",
    micGradeLevel: "Cấp",
    micGradeIncome: "Thu nhập Gold Beans 7 ngày",
    micGradeHourly: "Lương theo giờ (Gold Beans/h)",
    micGradeDaily: "Giới hạn ngày",
    micGradeBeans: "{beans} Gold Beans ({usd})",
    micGradeDailyLimit: "2 giờ",
    micExplainTitle: "3. Giải thích",
    micExplain1:
      "a. RainChat sẽ tính cấp độ của bạn dựa trên thu nhập Gold Beans trong 7 ngày gần nhất (hiện tại + 6 ngày trước)",
    micExplain2: "b. Dữ liệu được cập nhật mỗi 10-15 phút.",
    micExplain3:
      "c. Theo cấp độ hiện tại, bạn có thể nhận phần thưởng theo giờ bằng Gold Beans tương ứng với cấp độ đó.",
    micExplain4:
      "d. Phần thưởng được nhận thủ công và sẽ vào tài khoản ngay sau khi nhận.",
    micExplain5: "e. Nếu không nhận trong ngày, phần thưởng sẽ hết hạn.",
    micExplain6: "f. Mỗi ngày có thể nhận tối đa 2 giờ thưởng theo giờ.",
    micExplain7:
      "g. Khi thu nhập Gold Beans 7 ngày gần nhất vượt giới hạn SS. Cứ thêm 700.000 Gold Beans, mức lương theo giờ sẽ tăng thêm 20.000.",
    micExplainExample: "Ví dụ: 7.700.000 Gold Beans, lương theo giờ 220.000.",
    micExplain8:
      'h. Khi đang hưởng "Ưu đãi 7 ngày", phần thưởng theo giờ "Cấp I" không khả dụng. Sau khi "Ưu đãi 7 ngày" kết thúc, bạn có thể nhận bình thường.',
    micExplain9:
      "i. Nếu phát hiện dùng thủ đoạn gian lận để trục lợi phần thưởng, tài khoản sẽ bị khóa.",
    nextRefresh: "Làm mới lần sau",
    recent7Days: "7 ngày gần nhất",
    micRangeTip: "Hôm nay + 6 ngày trước\nCần trở thành host",
    totalIncome: "Tổng thu nhập",
    upgradeDesc: "Còn thiếu {remain} để nâng cấp, thưởng tăng {bonus}",
    ssBonusDesc: "Mỗi 700K Gold Beans tăng thêm, tiền thưởng tăng thêm 20K Gold Beans.",
    completeAllTask: "Hoàn thành tất cả nhiệm vụ có thể nhận",
    claim: "Nhận",
    grantSuccess: "Phát thưởng thành công",
    thisTimeGot: "Lần này nhận được",
    grantedToAccount: "Phần thưởng đã vào tài khoản của bạn",
    gotIt: "Đã hiểu",
    claimFail: "Nhận thất bại, vui lòng thử lại sau",
    micTaskName: "Phát sóng/lên mic {minutes} phút hôm nay",
  },
  guildApply: {
    "title": "Đơn xin vào guild",
    "pendingCount": "{count} đang chờ",
    "autoApproveTip": "Đơn trên 7 ngày tự duyệt, hãy xem ngay",
    "joinRequest": "({rainId}) muốn vào guild",
    "daysRemaining": "Còn {days} ngày",
    "appliedWithinOneDay": "Đăng ký trong 1 ngày",
    "appliedDaysAgo": "{days} ngày trước",
    "boundDays": "Ngày gắn: {days}",
    "incomeTier": "Hạng thu nhập: {level}",
    "applyToGuild": "Xin vào guild",
    "reject": "Từ chối",
    "approve": "Chấp nhận",
    "noPendingRequests": "Không có đơn chờ",
    "approved": "Đã chấp nhận",
    "rejected": "Đã từ chối",
    "approvalConfirmTitle": "Lưu ý",
    "approvalConfirmMessage": "Sau khi chấp thuận, người dùng sẽ gia nhập guild khác và sẽ không còn mang lại hoa hồng thu nhập cho bạn.",
    "back": "Quay lại",
    "pendingList": "Đơn chờ xử lý",
    "noToken": "Không tìm thấy token đăng nhập",
    "listLoadFailed": "Tải danh sách đơn thất bại",
    "listLoadFailedRetry": "Tải danh sách đơn thất bại, thử lại sau",
    "operationFailedRetry": "Thao tác thất bại, thử lại sau"
  },
  inviteFriendsNew: {
    "inviteRanking": "Bảng xếp hạng mời",
    "messages": "Tin nhắn",
    "totalRewards": "Tổng thưởng mời",
    "earnings": "Thu nhập",
    "totalValue": "Tổng giá trị",
    "viewDetails": "Xem chi tiết",
    "inviteStats": "Thống kê mời",
    "totalInvites": "Tổng",
    "todayInvites": "Hôm nay",
    "details": "Chi tiết",
    "inviteFriends": "Mời bạn",
    "copyLink": "Sao chép link",
    "close": "Đóng",
    "saveImage": "Lưu ảnh",
    "inviteModal": "Cửa sổ mời bạn",
    "rightTools": "Lối vào trang",
    "noToken": "Không tìm thấy token đăng nhập",
    "rewardsLoadFailed": "Tải thu nhập mời thất bại",
    "rewardsLoadFailedRetry": "Tải thu nhập mời thất bại, thử lại sau",
    "inviteInfoLoadFailed": "Tải thông tin mời thất bại",
    "inviteInfoLoadFailedRetry": "Tải thông tin mời thất bại, thử lại sau",
    "linkNotReady": "Link mời chưa sẵn sàng",
    "linkCopied": "Đã sao chép link mời",
    "copyFailedRetry": "Sao chép thất bại, thử lại sau",
    "saveFailedRetry": "Lưu ảnh thất bại, thử lại sau"
  },
  inviteRanking: {
    "title": "Bảng xếp hạng",
    "earningsRank": "Hạng thu nhập",
    "inviteRank": "Hạng mời",
    "day": "Ngày",
    "week": "Tuần",
    "total": "Tổng",
    "people": "Người",
    "noToken": "Không tìm thấy token đăng nhập",
    "loadFailed": "Tải bảng xếp hạng thất bại",
    "loadFailedRetry": "Tải bảng xếp hạng thất bại, thử lại sau"
  },
  inviterInformation: {
    "title": "Lời mời của tôi",
    "earnings": "Thu nhập",
    "members": "Thành viên",
    "filter": "Lọc:",
    "earningsTrend": "Xu hướng thu nhập",
    "dailyInvites": "Mời mỗi ngày",
    "verifiedHost": "MC đã xác thực",
    "inGuild": "Đã vào guild",
    "contact": "Liên hệ",
    "level1Earnings": "Thu nhập cấp 1",
    "level2Earnings": "Thu nhập cấp 2",
    "totalUsd": "Tổng (USD)",
    "loading": "Đang tải...",
    "noMore": "Hết rồi",
    "noData": "Không có dữ liệu",
    "back": "Quay lại",
    "tabTypes": "Loại thông tin người mời",
    "dateFilter": "Lọc ngày",
    "noToken": "Không tìm thấy token đăng nhập",
    "trendLoadFailed": "Tải dữ liệu xu hướng thất bại",
    "trendLoadFailedRetry": "Tải dữ liệu xu hướng thất bại, thử lại sau",
    "listLoadFailed": "Tải danh sách người mời thất bại",
    "listLoadFailedRetry": "Tải danh sách người mời thất bại, thử lại sau"
  },
  rewardSource: {
    "title": "Chi tiết thưởng",
    "pleaseSelect": "Chọn",
    "activityEarnings": "Hoạt động",
    "rechargeEarnings": "Nạp",
    "gameCommission": "Game",
    "incomeCommission": "Thu nhập",
    "back": "Quay lại"
  },
  rewardSourceRule: {
    "back": "Quay lại",
    "active": {
      "title": "Quy định về hoạt động mời bạn bè",
      "bindTitle": "Cách liên kết bạn bè",
      "bindSteps": [
        "Bước 1: Tại trang chủ của sự kiện mời bạn bè, nhấn nút “Mời” ở phía dưới để lưu hình ảnh hoặc sao chép liên kết mời riêng.",
        "Bước 2: Gửi hình ảnh đã lưu hoặc liên kết mời riêng cho bạn bè.",
        "Bước 3: Bạn bè sử dụng mã QR trên hình ảnh hoặc liên kết mời riêng để tải ứng dụng và đăng ký tài khoản. Sau khi đăng ký thành công, bạn bè sẽ được liên kết với tài khoản của bạn."
      ],
      "questionTitle": "Câu hỏi: Tại sao không thể liên kết bạn bè?",
      "answer": "Trả lời: Mỗi điện thoại chỉ có thể liên kết với một tài khoản. Có thể bạn của bạn đã liên kết với một tài khoản khác từ trước.",
      "userTitle": "Quy định về người dùng hoạt động",
      "userIntro": "Những người bạn đã liên kết với tài khoản của bạn sẽ giúp tăng số lượng người dùng hoạt động cho bạn khi hoàn thành các nhiệm vụ hoạt động hằng ngày.",
      "tasks": [
        "Nhiệm vụ 1\nLên mic và bật mic trong 2 giờ.",
        "Nhiệm vụ 2\nDoanh thu Game đạt 1.000 Xu.",
        "Điều kiện: Người dùng phải hoàn thành xác minh.",
        "Chỉ cần hoàn thành một trong hai nhiệm vụ trên, bạn bè đó sẽ được tính là 1 người dùng hoạt động cho bạn.",
        "Mỗi người bạn chỉ có thể đóng góp 1 người dùng hoạt động hợp lệ/ngày."
      ],
      "userNotes": [
        "Tính từ ngày đăng ký, mỗi người bạn được liên kết chỉ có thể đóng góp người dùng hoạt động hợp lệ trong 7 ngày đầu tiên.",
        "Mỗi người bạn được liên kết tối đa có thể đóng góp 7 lần người dùng hoạt động hợp lệ."
      ],
      "rewardTitle": "Phần thưởng người dùng hoạt động",
      "rewardIntro": "Khi số lượng người dùng hoạt động hợp lệ mỗi ngày của bạn đạt đến số lượng nhất định, bạn sẽ nhận được phần thưởng Kim Đậu.",
      "rewardTableIntro": "Phần thưởng",
      "rewardTableLabel": "Bảng phần thưởng Kim Đậu người dùng hoạt động",
      "rewardHeaders": ["Số lượng người dùng hoạt động hằng ngày", "Thưởng đậu vàng", "$"],
      "rewardNotes": [
        "Mỗi ngày có thể nhận phần thưởng cao nhất trị giá 70 USD.",
        "Phần thưởng của ngày hôm trước sẽ được mở để nhận thủ công vào lúc 10:00 ngày hôm sau.",
        "Vị trí nhận thưởng: Tab Livestream hoặc nút nổi “Phần thưởng” trong phòng livestream.",
        "Sau khi phần thưởng được phát hành, bạn cần nhận trong ngày, nếu không phần thưởng sẽ hết hạn. Nếu có phần thưởng, vui lòng nhận sớm."
      ],
      "noticeTitle": "Lưu ý",
      "notices": [
        "Mỗi điện thoại chỉ được liên kết với một tài khoản.",
        "Người bạn được liên kết phải hoàn thành xác minh thì mới được tính vào số lượng người dùng hoạt động.",
        "Danh sách chỉ hiển thị những người dùng đăng ký trong vòng 7 ngày gần nhất.",
        "Nếu phát hiện sử dụng các phương thức không hợp lệ để liên kết hoặc gian lận số lượng người dùng, nền tảng sẽ không phát thưởng. Trường hợp nghiêm trọng có thể bị khóa tài khoản và áp dụng các biện pháp xử lý khác."
      ]
    },
    "game": {
      "title": "Quy định chia hoa hồng Game",
      "levelTitle": "Cơ chế cấp bậc chia hoa hồng Game",
      "levelText": "Cấp bậc của bạn được xác định dựa trên tổng doanh số Game của 3 tầng trong đội nhóm, bao gồm: bản thân, thành viên cấp 1 và thành viên cấp 2.\nDoanh số càng cao → cấp bậc càng cao → thu nhập càng nhiều.",
      "rewardTitle": "Cơ cấu phần thưởng",
      "rewards": [
        "Hoa hồng cấp 1: Nhận phần chia hoa hồng trực tiếp từ doanh số Game của thành viên cấp 1.",
        "Hoa hồng cấp 2: Nếu cấp bậc của thành viên cấp 1 thấp hơn bạn, bạn sẽ nhận thêm phần thu nhập chênh lệch từ thành viên cấp 2."
      ],
      "tierTitle": "Bảng cấp bậc chia hoa hồng Game",
      "tierLabel": "Bảng cấp bậc chia hoa hồng Game",
      "tierHeaders": ["Cấp bậc", "Tổng doanh số Game của đội nhóm trong 30 ngày", "Tỷ lệ chia hoa hồng"],
      "tierNote": "Cấp bậc của bạn được đánh giá dựa trên doanh số Game của đội nhóm trong 30 ngày.",
      "assessmentTitle": "Quy định phát thưởng và đánh giá cấp bậc",
      "assessments": [
        "Mỗi ngày vào 00:00, hệ thống sẽ thống kê doanh số Game của đội nhóm trong 30 ngày trước đó để xác định cấp bậc.",
        "Đồng thời, hệ thống sẽ căn cứ vào cấp bậc được xác định để tính thưởng của ngày hôm trước."
      ],
      "exampleTitle": "Ví dụ minh họa",
      "examples": [
        "Ví dụ 1: Bạn đạt Lv.5 → nhận 0,5% từ doanh số Game do thành viên cấp 1 tạo ra.",
        "Ví dụ 2: Bạn đạt Lv.5, một thành viên cấp 1 của bạn đạt Lv.3. Doanh số Game của các thành viên cấp 2 do người này mời sẽ mang lại cho bạn 0,2%.\nCách tính:\n0,5% - 0,3% = 0,2%",
        "Ví dụ 3: Bạn đạt Lv.5, một thành viên cấp 1 của bạn cũng đạt Lv.5. Doanh số Game của các thành viên cấp 2 do người này mời sẽ không mang lại phần thưởng cho bạn, vì chênh lệch tỷ lệ hoa hồng bằng:\n0,5% - 0,5% = 0%"
      ],
      "detailTitle": "Ví dụ chi tiết về cách tính",
      "detailTeamTitle": "Tính cấp bậc đội nhóm A",
      "detailTeams": [
        {
          "title": "Đội nhóm A",
          "lines": [
            "Doanh số bản thân + doanh số thành viên cấp 1 + doanh số thành viên cấp 2",
            "A + B + C + D + E + F + G\n= 10M + 20M + 10M + 5M + 800M + 200M + 10M\n= 1.055M Xu",
            "→ Cấp Lv.5\n→ Tỷ lệ chia hoa hồng: 0,5%"
          ]
        },
        {
          "title": "Đội nhóm B — thành viên cấp 1 của A",
          "lines": [
            "B + E + F\n= 20M + 800M + 200M = 1.020M Xu",
            "→ Cấp Lv.5\n→ Tỷ lệ chia hoa hồng: 0,5%"
          ]
        },
        {
          "title": "Đội nhóm C — thành viên cấp 1 của A",
          "lines": [
            "C + G\n= 10M + 10M = 20M Xu",
            "→ Cấp Lv.2\n→ Tỷ lệ chia hoa hồng: 0,2%"
          ]
        }
      ],
      "detailIncomeTitle": "Thu nhập của A",
      "detailIncomeGroups": [
        {
          "title": "Hoa hồng trực tiếp từ thành viên cấp 1 (B, C, D)",
          "plainLines": [
            "Công thức:",
            "(Doanh số của B + C + D) × tỷ lệ hoa hồng của A",
            "= (20M + 10M + 5M) × 0,5%",
            "= 35M × 0,5%",
            "= 175.000 Xu",
            "≈ 17,50 USD"
          ]
        },
        {
          "title": "Hoa hồng chênh lệch từ thành viên cấp 2 (E, F, G)",
          "numberedItems": [
            {
              "title": "Từ E và F:",
              "plainLines": [
                "(A 0,5% - B 0,5%) × (800M + 200M)",
                "= 0% × 1.000M = 0 USD",
                "Do tỷ lệ hoa hồng của A và B bằng nhau nên không có phần hoa hồng chênh lệch."
              ]
            },
            {
              "title": "Từ G:",
              "plainLines": [
                "(A 0,5% - C 0,2%) × G",
                "= (0,5% - 0,2%) × 10M",
                "= 0,3% × 10M",
                "= 30.000 Xu",
                "≈ 3,00 USD",
                "Do tỷ lệ hoa hồng của A cao hơn C 0,3%, A nhận được 0,3% doanh số Game của G."
              ]
            }
          ]
        }
      ]
    },
    "income": {
      "title": "Quy định chia hoa hồng thu nhập",
      "levelTitle": "Cơ chế cấp bậc chia hoa hồng thu nhập",
      "levelText": "Cách xác định cấp bậc:\nCấp bậc của bạn được xác định dựa trên tổng thu nhập của 3 tầng trong đội nhóm, bao gồm: thu nhập của bạn, thành viên cấp 1 và thành viên cấp 2.\nThu nhập đội nhóm càng cao → cấp bậc càng cao → thu nhập nhận được càng nhiều.",
      "rewardTitle": "Thành phần thu nhập",
      "rewards": [
        "Thu nhập của bản thân.",
        "Thu nhập của thành viên cấp 1.",
        "Thu nhập của thành viên cấp 2."
      ],
      "tierTitle": "Bảng cấp bậc và tỷ lệ chia hoa hồng",
      "tierLabel": "Bảng cấp bậc và tỷ lệ chia hoa hồng",
      "tierHeaders": ["Cấp bậc", "Thu nhập Kim Đậu của đội nhóm trong 30 ngày gần nhất", "Tỷ lệ chia hoa hồng"],
      "tierNote": "Lưu ý: Cấp bậc của bạn được đánh giá dựa trên tổng thu nhập của đội nhóm trong 30 ngày gần nhất.",
      "sPlusTierText": "Có 2 thành viên cấp 1 đạt cấp S",
      "sPlusTitle": "Cấp S+",
      "sPlus": [
        "Nếu trong đội nhóm của bạn có 2 thành viên cấp 1 cùng đạt cấp S, bạn sẽ được nâng lên cấp S+.",
        "Tỷ lệ chia hoa hồng: 21%."
      ],
      "assessmentTitle": "Quy định về phát thưởng và đánh giá cấp bậc",
      "assessments": [
        "Mỗi ngày vào 00:00, hệ thống sẽ thống kê doanh thu của đội nhóm trong 30 ngày trước đó để xác định cấp bậc của bạn.",
        "Đồng thời, hệ thống sẽ căn cứ vào cấp bậc được xác định để tính và trả thưởng của ngày hôm trước."
      ],
      "exampleTitle": "Ví dụ minh họa",
      "examples": [
        "Ví dụ 1\nBạn ở cấp S, mọi khoản thu nhập từ quà tặng của bản thân sẽ được nhận 20% Đậu vàng thưởng.",
        "Ví dụ 2\nBạn ở cấp S, thành viên cấp 1 của bạn ở cấp A.\nBạn sẽ nhận được 2% Đậu vàng từ thu nhập quà tặng của thành viên cấp 1 này và các thành viên cấp 2 do họ mời.\nLý do:\n20% - 18% = 2%",
        "Ví dụ 3\nBạn ở cấp S, và một thành viên cấp 1 của bạn cũng ở cấp S.\nBạn sẽ không nhận được phần thưởng từ thành viên cấp 1 này.",
        "Ví dụ 4\nNếu bạn có 2 thành viên cấp 1 đều đạt cấp S, bạn sẽ được nâng lên cấp S+, với tỷ lệ chia hoa hồng 21%.\nKhi đó, bạn vẫn có thể nhận được 1% thưởng từ thu nhập của họ."
      ],
      "noticeTitle": "Lưu ý",
      "notices": [
        "Nếu một thành viên trong đội nhóm của bạn tham gia Guild, thành viên đó sẽ không còn được tính vào doanh thu đội nhóm của bạn và sẽ không tạo ra thưởng từ thu nhập quà tặng cho bạn.",
        "Cấp bậc được xác định dựa trên thu nhập Đậu vàng từ quà tặng của đội nhóm trong 30 ngày gần nhất.",
        "Thành viên phải được xác minh là Host thì thu nhập mới được tính."
      ],
      "detailTitle": "Ví dụ chi tiết về cách tính",
      "detailGroups": [
        {
          "title": "Tính cấp bậc đội nhóm",
          "items": [
            {
              "title": "Đội nhóm A",
              "points": [
                { "title": "Thu nhập của A + B + C + D + E + F:", "lines": [] },
                { "title": "20M + 156M + 98M + 40M + 4M + 2M = 320M", "lines": [] },
                { "title": "→ Đạt cấp S\n→ Tỷ lệ chia hoa hồng: 20%", "lines": [] }
              ]
            },
            {
              "title": "Đội nhóm B",
              "points": [
                { "title": "Thu nhập của B + D + E:", "lines": [] },
                { "title": "156M + 40M + 4M = 200M", "lines": [] },
                { "title": "→ Đạt cấp A\n→ Tỷ lệ chia hoa hồng: 18%", "lines": [] }
              ]
            },
            {
              "title": "Đội nhóm C",
              "points": [
                { "title": "Thu nhập của C + F:", "lines": [] },
                { "title": "98M + 2M = 100M", "lines": [] },
                { "title": "→ Đạt cấp A\n→ Tỷ lệ chia hoa hồng: 18%", "lines": [] }
              ]
            }
          ]
        },
        {
          "title": "Tính thu nhập của A",
          "items": [
            {
              "title": "Thu nhập của bản thân",
              "points": [
                { "title": "Thu nhập của A × tỷ lệ cấp A:", "lines": [] },
                { "title": "20M × 20% = 4.000.000 Đậu vàng", "lines": [] }
              ]
            },
            {
              "title": "Thu nhập từ thành viên cấp 1",
              "points": [
                { "title": "Thành viên B:", "lines": ["156M × (20% - 18%)\n= 3.120.000 Đậu vàng"] },
                { "title": "Thành viên C:", "lines": ["98M × (20% - 18%)\n= 1.960.000 Đậu vàng"] }
              ]
            },
            {
              "title": "Thu nhập từ thành viên cấp 2",
              "points": [
                { "title": "Thành viên D và E — thành viên trong đội của B:", "lines": ["(40M + 4M) × (20% - 18%)\n= 880.000 Đậu vàng"] },
                { "title": "Thành viên F — thành viên trong đội của C:", "lines": ["2M × (20% - 18%)\n= 40.000 Đậu vàng"] }
              ]
            }
          ]
        },
        {
          "title": "Tổng thu nhập",
          "numberedLines": [
            "Thu nhập thêm từ bản thân: 4M Đậu vàng",
            "Thu nhập chênh lệch từ người được mời:\n3,12M + 1,96M + 0,88M + 0,04M = 6M Đậu vàng",
            "Tổng thu nhập: 10M Đậu vàng"
          ]
        }
      ]
    },
    "recharge": {
      "title": "Quy định thưởng nạp tiền",
      "cashbackTitle": "Hoàn tiền nạp tiền",
      "cashback": [
        "Trong vòng 30 ngày kể từ khi bạn bè đăng ký, mọi khoản nạp tiền của họ sẽ mang lại cho bạn thưởng hoàn tiền nạp.",
        "Những người bạn do bạn bè của bạn mời cũng sẽ mang lại cho bạn thưởng hoàn tiền nạp trong vòng 30 ngày kể từ khi họ đăng ký."
      ],
      "chainTitle": "Mối quan hệ giới thiệu",
      "chainIntro": "Ví dụ: A mời B, B mời C, C mời D.",
      "chainAlt": "Sơ đồ mối quan hệ giới thiệu A, B, C, D",
      "chainExamples": [
        "B nạp 10.000 Xu → A nhận được 200 Xu (hoàn 2%).",
        "C nạp 10.000 Xu → B nhận được 200 Xu (hoàn 2%), A nhận được 100 Xu (hoàn 1%).",
        "D nạp 10.000 Xu → C nhận được 200 Xu (hoàn 2%), B nhận được 100 Xu (hoàn 1%), A không còn nhận được thưởng hoàn tiền từ D.",
        "Người được bạn trực tiếp mời (cấp 1) sẽ mang lại cho bạn 2% tiền hoàn.",
        "Người được mời gián tiếp (cấp 2) sẽ mang lại cho bạn 1% tiền hoàn."
      ],
      "validityTitle": "Thời hạn hiệu lực 30 ngày",
      "validity": [
        "Trong vòng 30 ngày kể từ khi người bạn được mời đăng ký, tất cả các khoản nạp tiền của người đó đều sẽ mang lại thưởng hoàn tiền cho người giới thiệu cấp trên.",
        "Sau khi vượt quá 30 ngày, các khoản nạp tiền phát sinh sẽ không còn được hưởng bất kỳ khoản thưởng hoàn tiền nào."
      ],
      "payoutTitle": "Quy định phát thưởng",
      "payout": [
        "Sau khi người dùng hoàn tất việc nạp tiền, phần thưởng sẽ được cộng ngay vào ví của bạn.",
        "Các hình thức nạp tiền bao gồm: nạp Xu trực tiếp và nạp qua đại lý."
      ]
    }
  },
  rewardSourceDetail: {
    "title": "Chi tiết nguồn thưởng",
    "rules": "Quy tắc",
    "activityEarnings": "Hoạt động",
    "rechargeEarnings": "Nạp",
    "gameCommission": "Game",
    "incomeCommission": "Thu nhập",
    "totalEarnings": "Tổng",
    "yesterdayEarnings": "Hôm qua",
    "todayEstimate": "Hôm nay",
    "todayActiveUsers": "Người dùng hiệu quả",
    "currentRankReward": "Thưởng hiện tại",
    "upgradeReward": "Thêm {count} người hoạt động để nâng thưởng {reward}",
    "maxRewardTier": "Đã đạt mức thưởng tối đa",
    "teamRevenue": "Tổng doanh thu team 30 ngày",
    "currentCommission": "Hoa hồng hiện tại",
    "upgradeCommission": "Cần {flow} doanh thu để đạt {rate}",
    "maxCommissionTier": "Đã đạt mức hoa hồng tối đa",
    "invitedUsers": "Người mời 7 ngày",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "certified": "Đã xác thực",
    "agency": "Agency",
    "micTime": "Thời gian lên mic",
    "minutes": "phút",
    "gameRevenue": "Doanh thu game",
    "coins": "Xu",
    "loading": "Đang tải...",
    "noMore": "Hết rồi",
    "noData": "Không có dữ liệu",
    "total": "Tổng cộng",
    "last7Days": "7 ngày qua",
    "yesterday": "Hôm qua",
    "today": "Hôm nay",
    "level1Commission": "Hoa hồng cấp 1",
    "level2Commission": "Hoa hồng cấp 2",
    "totalIncome": "Tổng thu nhập",
    "commissionRate": "Tỷ lệ hoa hồng",
    "upgradeGap": "Còn {amount} để nâng cấp",
    "activeHelpUpdate": "Dữ liệu cập nhật sau 10-15 phút",
    "activeHelpReward": "Nhận thưởng tại trang \"Trang chủ-Thưởng\" lúc 10h ngày hôm sau",
    "rechargeHelpUpdate": "Dữ liệu cập nhật sau 10-15 phút",
    "rechargeHelpReward": "Thưởng nhận ngay sau khi người dùng nạp tiền",
    "gameHelpUpdate": "Dữ liệu cập nhật sau 10-15 phút",
    "gameHelpReward": "Hệ thống phát thưởng ngày hôm sau",
    "roomHelpUpdate": "Dữ liệu cập nhật sau 10-15 phút",
    "roomHelpCommission": "Bao gồm: hoa hồng của bạn, thành viên cấp 1, cấp 2",
    "roomHelpReward": "Hệ thống phát thưởng ngày hôm sau",
    "back": "Quay lại",
    "viewHelp": "Xem giải thích",
    "todayEstimateHelp": "Giải thích ước tính hôm nay"
  },
};
